
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hcVGp", function(module, exports) {
$parcel$export(module.exports, "GlobalNav", function () { return $e87e996a56dac08a$export$963222cd47bfd015; });
/* nav-global.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $izdHQ = parcelRequire("izdHQ");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5X1Oi = parcelRequire("5X1Oi");

var $bvLTq = parcelRequire("bvLTq");

var $aBl7x = parcelRequire("aBl7x");

var $3pg5Q = parcelRequire("3pg5Q");

var $Q3GOe = parcelRequire("Q3GOe");

var $8DdYy = parcelRequire("8DdYy");

var $gisLk = parcelRequire("gisLk");

var $hiOEV = parcelRequire("hiOEV");

var $jUCHH = parcelRequire("jUCHH");

var $jHmlF = parcelRequire("jHmlF");

var $3hAMp = parcelRequire("3hAMp");

var $ibZL7 = parcelRequire("ibZL7");

var $igXd8 = parcelRequire("igXd8");

var $4Rcm1 = parcelRequire("4Rcm1");

var $9KOR3 = parcelRequire("9KOR3");

var $aFrXh = parcelRequire("aFrXh");

var $96jet = parcelRequire("96jet");

var $5BEho = parcelRequire("5BEho");
const $e87e996a56dac08a$export$d6a07a1754b0e052 = (0, $4Rcm1.navLayout).height;
const $e87e996a56dac08a$var$navigationShellCss = null;
const $e87e996a56dac08a$var$expandedMobileShellCss = null;
// Compiled supports the calculated grid tracks needed to align with the page grid.
const $e87e996a56dac08a$var$navigationBarContentCss = null;
const $e87e996a56dac08a$var$desktopControlsCss = null;
const $e87e996a56dac08a$var$mobileControlsCss = null;
const $e87e996a56dac08a$var$mobileMenuCss = null;
const $e87e996a56dac08a$var$navigationBarSearchCss = null;
const $e87e996a56dac08a$var$navigationBarLogoCss = null;
const $e87e996a56dac08a$var$navigationBarLogoLink = null;
const $e87e996a56dac08a$var$navigationBarLogoImageCss = null;
const $e87e996a56dac08a$var$isStickyNavCss = null;
const $e87e996a56dac08a$export$b9a265e5df299ef2 = ({ productKey: productKey, isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = false, isShowSearchButton: isShowSearchButton = true, tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor, globalLinksProps: globalLinksProps, tryNowLinkCtaUrl: tryNowLinkCtaUrl })=>{
    const intl = (0, $8e22h.default)();
    const atlasUrl = (0, $jQ0cd.useLocalizedHref)('/');
    const [isOpenSearch, setIsOpenSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(false);
    const mobileState = (0, $hiOEV.useMobileNavDisplay)(isOpenSearch);
    const globalLinksRef = (0, $1oC0p.useRef)(null);
    const searchAndProfileRef = (0, $1oC0p.useRef)(null);
    const hasMounted = (0, $1oC0p.useRef)(false);
    const navRef = (0, $1oC0p.useRef)(null);
    const { showMoreItems: setShowMore, shouldShowMoreItems: showMore, maxItems: maxLinks } = (0, $jUCHH.useMore)({
        leftElementRef: globalLinksRef,
        rightElementRef: searchAndProfileRef,
        initialMaxItems: globalLinksProps.length,
        buffer: 24
    });
    (0, $1oC0p.useEffect)(()=>{
        if (hasMounted.current) {
            const searchButton = Array.from(navRef.current?.querySelectorAll('#global-nav-search-bar-icon-desktop') ?? []).find((button)=>button.getClientRects().length > 0);
            if (searchButton) searchButton.focus();
        } else hasMounted.current = true;
    }, [
        isOpenSearch
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
        ref: navRef,
        "aria-label": intl.formatMessage({
            id: 'wacGlobalNavigation.nav-label',
            defaultMessage: 'Main'
        }),
        className: (0, $2jatx.default)([
            "_p42h1b66 _bfhk1afi _18zr1n1m _1rjcidpf _vchhusvi _1s0lidpf _165t18pe",
            mobileState.showMenu && "_13zm1n9t _xaejidpf _1eg6idpf _1rfm1osq _tnru1kxc _1o831wug _98bk1wug _2rfoqfx8"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1mhfb35": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).outerInset),
            "--_eiqaqt": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).height)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c11p5 _yv0ehpfy _4t3i18pe _4cvr1h6o _kqswh2mm _12qzi47z _165t1osq _1rqtvol0 _tyveoxdy"
                ]),
                style: {
                    "--_eiqaqt": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).height),
                    "--_m1f5bg": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).globalColumnsDesktop),
                    "--_1cmqt4n": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).globalColumnsWide)
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1q511b66"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5BEho.SkipToContent), {
                                alignToLogo: true
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                "data-testid": "navigation-bar-logo-link",
                                href: atlasUrl,
                                "aria-label": intl.formatMessage({
                                    id: 'wacGlobalNavigation.logo-label',
                                    defaultMessage: 'Atlassian logo'
                                }),
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "globalNavWac",
                                "data-product-key": productKey,
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bsbvb5u _4t3it8ph _1o9zidpf"
                                ]),
                                style: {
                                    "--_1ycknng": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).atlassianLogoWidth),
                                    "--_1q2cqym": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).logoHeight)
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1bsb1osq _4t3i1osq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                        brand: "atlassian",
                                        type: "logo",
                                        appearance: "brand",
                                        width: "100%",
                                        height: "100%"
                                    })
                                })
                            })
                        ]
                    }),
                    isOpenSearch ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _yyhy1jtt _1ul9idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $96jet.default), {
                            isOpenSearch: isOpenSearch,
                            setIsOpenSearch: setIsOpenSearch,
                            parentType: "GlobalNav"
                        })
                    }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0cglyw _dm251bgi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.default), {
                                        alignDropdownsToGlobalMenu: true,
                                        globalLinksProps: globalLinksProps,
                                        globalLinksRef: globalLinksRef,
                                        maxLinks: maxLinks,
                                        showMore: showMore,
                                        setShowMore: setShowMore
                                    }),
                                    isShowSearchBarAndProfileContainer && !showMore && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $izdHQ.FeatureExposed), {
                                        experimentKey: "wac-globalui-team24-globalnav-cta",
                                        group: "test",
                                        conditions: [
                                            !isShowTryNowLink
                                        ],
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aFrXh.NavUtilities), {
                                            isShowTryNowLink: isShowTryNowLink,
                                            // @ts-expect-error -- Existing legacy CTA color prop.
                                            ctaButtonColor: tryNowLinkCtaButtonColor,
                                            productKey: productKey,
                                            isShowSearchButton: isShowSearchButton,
                                            setIsOpenSearch: setIsOpenSearch,
                                            searchAndProfileRef: searchAndProfileRef,
                                            navigationTrynowCtaUrl: tryNowLinkCtaUrl
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1bahesu3 _1ul9idpf _10y4glyw"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ibZL7.MobileNavTop), {
                                    showLogo: false,
                                    productKey: productKey,
                                    isLoggedIn: mobileState.userInfo.isUserLoggedIn,
                                    userName: mobileState.userInfo.name ?? '',
                                    picture: mobileState.userInfo.picture ?? '',
                                    handleClickAvatar: mobileState.handleClickAvatar,
                                    showMenu: mobileState.showMenu,
                                    handleToggleMenu: mobileState.handleToggleMenu,
                                    menuPage: mobileState.menuPage,
                                    handleMenuPage: mobileState.handleMenuPage,
                                    handleFirstOpen: mobileState.handleFirstOpen,
                                    isShowSearchButton: isShowSearchButton,
                                    isOpenSearch: isOpenSearch,
                                    setIsOpenSearch: setIsOpenSearch,
                                    tabletDropdownMenu: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3hAMp.GlobalNavMobileMenu), {
                                        productKey: productKey,
                                        state: mobileState
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            mobileState.showMenu && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                id: "nav-mobile-dropdown-menu",
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule _476dutpp"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3hAMp.GlobalNavMobileMenu), {
                    productKey: productKey,
                    state: mobileState
                })
            })
        ]
    });
};
const $e87e996a56dac08a$export$963222cd47bfd015 = ({ productKey: productKey = 'home', isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer = true, isShowTryNowLink: isShowTryNowLink = false, isShowSearchButton: isShowSearchButton = true, tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor, isNavSticky: isNavSticky = true, tryNowLinkCtaUrl: tryNowLinkCtaUrl, compoundNav: compoundNav })=>{
    const intl = (0, $8e22h.default)();
    const hasScrolled = (0, $jHmlF.useNavScrollShadow)();
    const isAiTabEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).team26EuRefresh);
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)('/enterprise');
    const globalLinksProps = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: 'products',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.products',
                    defaultMessage: 'Products'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.GlobalNavProductsDropdown), {
                    productKey: productKey
                }),
                layout: (0, $9KOR3.GlobalNavDropdownLayout).Product
            },
            ...isAiTabEnabled ? [
                {
                    globalLinksKey: 'ai',
                    linkText: intl.formatMessage({
                        id: 'globalNavigation.Navlink.ai',
                        defaultMessage: 'AI'
                    }),
                    hasDropdown: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5X1Oi.AiContent), {
                        productKey: productKey
                    }),
                    layout: (0, $9KOR3.GlobalNavDropdownLayout).AI
                }
            ] : [],
            {
                globalLinksKey: 'solutions',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.solutions',
                    defaultMessage: 'Solutions'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8DdYy.GlobalNavSolutionsDropdown), {
                    productKey: productKey
                }),
                layout: (0, $9KOR3.GlobalNavDropdownLayout).Solutions
            },
            {
                globalLinksKey: 'why-atlassian',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.whyAtlassian',
                    defaultMessage: 'Why Atlassian'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gisLk.GlobalNavWhyAtlassianDropdown), {
                    productKey: productKey
                }),
                layout: (0, $9KOR3.GlobalNavDropdownLayout).WhyAtlassian
            },
            {
                globalLinksKey: 'resources',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.resources',
                    defaultMessage: 'Resources'
                }),
                hasDropdown: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $Q3GOe.GlobalNavResourcesDropdown), {
                    productKey: productKey
                }),
                layout: (0, $9KOR3.GlobalNavDropdownLayout).Resources
            },
            {
                globalLinksKey: 'enterprise',
                linkText: intl.formatMessage({
                    id: 'globalNavigation.Navlink.enterprise',
                    defaultMessage: 'Enterprise'
                }),
                hasDropdown: false,
                href: enterpriseHref
            }
        ], // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        enterpriseHref,
        intl,
        isAiTabEnabled,
        productKey
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return globalLinksProps.map((globalLink)=>globalLink.globalLinksKey);
    }, [
        globalLinksProps
    ]);
    const navProductRecosResponse = (0, $aBl7x.useGlobalNavProductRecommendations)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "global-nav-v2",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-nav-dropdown-boundary": true,
            className: (0, $2jatx.default)([
                "_kqswh2mm _16qs1nxu _v5641tcc _sedtglyw _1pbyqfx8 _bfhk1afi",
                isNavSticky && "_kqsw1if8 _152tidpf"
            ]),
            style: {
                "--_127dc5p": (0, $6ZVlx.default)(hasScrolled ? (0, $jHmlF.NAV_SCROLL_SHADOW) : 'none'),
                "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bvLTq.NavProductRecommendationsContext).Provider, {
                value: navProductRecosResponse,
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9KOR3.GlobalNavProvider), {
                    globalNavItemKeys: globalNavItemKeys,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($e87e996a56dac08a$export$b9a265e5df299ef2, {
                            productKey: productKey,
                            isShowSearchBarAndProfileContainer: isShowSearchBarAndProfileContainer,
                            isShowTryNowLink: isShowTryNowLink,
                            tryNowLinkCtaUrl: tryNowLinkCtaUrl,
                            isShowSearchButton: isShowSearchButton,
                            tryNowLinkCtaButtonColor: tryNowLinkCtaButtonColor,
                            globalLinksProps: globalLinksProps
                        }),
                        compoundNav && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igXd8.CompoundSubNav), {
                            ...compoundNav
                        })
                    ]
                })
            })
        })
    });
};
$e87e996a56dac08a$export$963222cd47bfd015.displayName = 'GlobalNav';

});
parcelRegister("5X1Oi", function(module, exports) {
$parcel$export(module.exports, "AiContent", function () { return $f3b2a28b3e8594be$export$f2a5a033ab82a5e2; });
/* ai-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $5Zqcl = parcelRequire("5Zqcl");

var $jbgN3 = parcelRequire("jbgN3");

var $9KOR3 = parcelRequire("9KOR3");
const $f3b2a28b3e8594be$var$aiContentCss = null;
const $f3b2a28b3e8594be$var$primaryContentCss = null;
const $f3b2a28b3e8594be$var$secondaryContentCss = null;
const $f3b2a28b3e8594be$var$horizontalGridCss = null;
const $f3b2a28b3e8594be$var$productCss = null;
const $f3b2a28b3e8594be$var$productIconCss = null;
const $f3b2a28b3e8594be$var$productTitleCss = null;
const $f3b2a28b3e8594be$var$productDescriptionCss = null;
const $f3b2a28b3e8594be$var$linkListCss = null;
const $f3b2a28b3e8594be$var$externalListCss = null;
const $f3b2a28b3e8594be$var$worksWithCss = null;
const $f3b2a28b3e8594be$var$linkCss = null;
const $f3b2a28b3e8594be$var$externalAiProductCss = null;
const $f3b2a28b3e8594be$var$externalAiProductIconCss = null;
const $f3b2a28b3e8594be$var$useTrackAiLinkClick = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    return (0, $1oC0p.useCallback)((label)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            actionSubjectId: 'globalNavAiLink',
            source: 'globalNavAiDropdown',
            attributes: {
                label: label
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
};
const $f3b2a28b3e8594be$var$InternalAiProduct = ({ description: description, href: href, icon: icon, title: title, productKey: productKey })=>{
    const trackAiLinkClick = $f3b2a28b3e8594be$var$useTrackAiLinkClick();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
        href: href,
        "aria-label": description ? `${title}: ${description}` : title,
        onClick: ()=>trackAiLinkClick(title),
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "globalNavAiDropdown",
        "data-label": title,
        "data-product-key": productKey,
        className: (0, $2jatx.default)([
            "_4cvr1y6m _syaz1pfd _1e0c1txw _zulpu2gc _6rthxy5q _85i51b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1ygb1qgu _1ah3yh40 _30l35hrz"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: [
            icon && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": "true",
                className: (0, $2jatx.default)([
                    "_4cvr1h6o _1e0c1txw _4t3iviql _1bah1h6o _1bsbviql"
                ]),
                children: icon
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_ect41vau _1wyboxwj _k48pni7l _vwz4kb7n"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                        },
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_syaz1qc2 _1wyboqnp _vwz4kb7n _1pfh1b66"
                        ]),
                        style: {
                            "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                        },
                        children: description
                    })
                ]
            })
        ]
    });
};
const $f3b2a28b3e8594be$var$ExternalAiProduct = ({ href: href, icon: icon, productKey: productKey, title: title })=>{
    const trackAiLinkClick = $f3b2a28b3e8594be$var$useTrackAiLinkClick();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            href: href,
            onClick: ()=>trackAiLinkClick(title),
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavAiDropdown",
            "data-label": title,
            "data-product-key": productKey,
            className: (0, $2jatx.default)([
                "_4cvr1h6o _syaz1pfd _1e0c1txw _1wyboxwj _zulpu2gc _vwz41by7 _1rjc1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1ygb1qgu _1ah3yh40 _30l35hrz"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    "aria-hidden": "true",
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1o9zidpf _4t3i1j6v _1bsb1j6v _4cvr1h6o"
                    ]),
                    children: icon
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    children: title
                })
            ]
        })
    });
};
const $f3b2a28b3e8594be$var$AiLink = ({ href: href, text: text, productKey: productKey })=>{
    const trackAiLinkClick = $f3b2a28b3e8594be$var$useTrackAiLinkClick();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: href,
            onClick: ()=>trackAiLinkClick(text),
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavAiDropdown",
            "data-label": text,
            "data-product-key": productKey,
            className: (0, $2jatx.default)([
                "_1e0c1ule _syaz1pfd _1wyboxwj _vwz41by7 _1rjc1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1ygb1qgu _1ah3yh40 _30l35hrz"
            ]),
            style: {
                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: text
        })
    });
};
const $f3b2a28b3e8594be$export$f2a5a033ab82a5e2 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    // apps
    const rovoHref = (0, $jQ0cd.useLocalizedHref)('/software/rovo');
    const teamworkGraphHref = (0, $jQ0cd.useLocalizedHref)('/platform/teamwork-graph');
    // apps help
    const aiTrustHref = (0, $jQ0cd.useLocalizedHref)('/trust/ai');
    const rovoStartHref = (0, $jQ0cd.useLocalizedHref)('/software/rovo/start');
    // ecosystem
    const rovoConnectorsHref = (0, $jQ0cd.useLocalizedHref)('/software/rovo/connectors');
    const mcpHref = (0, $jQ0cd.useLocalizedHref)('/platform/rovo-mcp');
    // works with
    const anthropicHref = (0, $jQ0cd.useLocalizedHref)('/partnerships/anthropic/guide');
    const googleHref = (0, $jQ0cd.useLocalizedHref)('/partnerships/google/guide');
    const githubHref = (0, $jQ0cd.useLocalizedHref)('/partnerships/github/guide');
    const openAiHref = (0, $jQ0cd.useLocalizedHref)('/partnerships/openai/guide');
    const platformLinks = [
        {
            href: 'https://developer.atlassian.com/platform/forge/',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.platform.buildwithforge',
                defaultMessage: 'Build with Forge'
            })
        },
        {
            href: aiTrustHref,
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.platform.aisecurity',
                defaultMessage: 'AI security and trust'
            })
        },
        {
            href: rovoStartHref,
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.platform.rovogetstarted',
                defaultMessage: 'Get started'
            })
        }
    ];
    const resourceLinks = [
        {
            href: 'https://www.atlassian.com/blog/company-news/ai-sdlc',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.evolvingjira',
                defaultMessage: 'Evolving Jira for AI-native software development'
            })
        },
        {
            href: 'https://www.atlassian.com/enterprise/success/fde',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.forwarddeployed',
                defaultMessage: 'Forward Deployed Engineering'
            })
        },
        {
            href: 'https://www.atlassian.com/blog/category/ai',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.aiblogsnews',
                defaultMessage: 'AI blogs & news'
            })
        },
        {
            href: 'https://www.atlassian.com/blog/ai-research',
            text: intl.formatMessage({
                id: 'globalnav.v2.ai.resources.airesearch',
                defaultMessage: 'AI research'
            })
        }
    ];
    const AiContentExternalLinksInfo = {
        anthropic: {
            title: 'Anthropic',
            href: anthropicHref,
            icon: (0, $5Zqcl.AiContentExternalLogoSvgs).anthropic
        },
        google: {
            title: 'Google',
            href: googleHref,
            icon: (0, $5Zqcl.AiContentExternalLogoSvgs).google
        },
        github: {
            title: 'GitHub',
            href: githubHref,
            icon: (0, $5Zqcl.AiContentExternalLogoSvgs).github
        },
        openAi: {
            title: 'OpenAI',
            href: openAiHref,
            icon: (0, $5Zqcl.AiContentExternalLogoSvgs).openAi
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-direction": direction,
            className: (0, $2jatx.default)([
                "_1e0c11p5 _yv0ehkll _1bsb1osq _1rqtpbuv"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_18zrxy5q _1q511jfw _xc2ize3t _1bhlze3t"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                            title: intl.formatMessage({
                                id: 'globalnav.v2.ai.mobiletitle',
                                defaultMessage: 'AI'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                            children: intl.formatMessage({
                                id: 'globalnav.ai.platform',
                                defaultMessage: 'AI platform'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _4cvr1y6m _gy1pxy5q _yv0e9sye _1pfhidpf _6rthpxbi _1ph4hkll _1egl1jfw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$InternalAiProduct, {
                                            title: intl.formatMessage({
                                                id: 'globalnav.ai.rovo.title',
                                                defaultMessage: 'Rovo'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'globalnav.ai.rovo.description',
                                                defaultMessage: 'AI that knows your business'
                                            }),
                                            href: rovoHref,
                                            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                                brand: "rovo",
                                                type: "mark",
                                                appearance: "brand",
                                                width: "32px",
                                                height: "32px"
                                            }),
                                            productKey: productKey
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$InternalAiProduct, {
                                            title: intl.formatMessage({
                                                id: 'globalnav.ai.teamworkGraph.title',
                                                defaultMessage: 'Teamwork Graph'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'globalnav.ai.teamworkGraph.description',
                                                defaultMessage: 'Context wherever you work'
                                            }),
                                            href: teamworkGraphHref,
                                            icon: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                                brand: "teamworkgraph",
                                                type: "mark",
                                                appearance: "brand",
                                                width: "32px",
                                                height: "32px"
                                            }),
                                            productKey: productKey
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _zulpu2gc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                                        ]),
                                        children: platformLinks.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$AiLink, {
                                                ...link,
                                                productKey: productKey
                                            }, link.text))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                            children: intl.formatMessage({
                                id: 'globalnav.ai.ecosystem',
                                defaultMessage: 'AI ecosystem'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _4cvr1y6m _gy1pxy5q _yv0e9sye _1pfhidpf _6rthpxbi _1ph4hkll _1egl1jfw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$InternalAiProduct, {
                                            title: intl.formatMessage({
                                                id: 'globalnav.ai.rovoconnectors.title',
                                                defaultMessage: 'Rovo Connectors'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'globalnav.ai.rovoconnectors.description',
                                                defaultMessage: 'Centralize your knowledge sources'
                                            }),
                                            href: rovoConnectorsHref,
                                            productKey: productKey
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$InternalAiProduct, {
                                            title: intl.formatMessage({
                                                id: 'globalnav.ai.atlassianmcp.title',
                                                defaultMessage: 'Atlassian MCP'
                                            }),
                                            description: intl.formatMessage({
                                                id: 'globalnav.ai.atlassianmcp.description',
                                                defaultMessage: 'Bring Atlassian into your AI tools'
                                            }),
                                            href: mcpHref,
                                            productKey: productKey
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_1pfhidpf _6rthutpp _1wyboxwj"
                                            ]),
                                            children: intl.formatMessage({
                                                id: 'globalnav.ai.workswith',
                                                defaultMessage: 'Works with:'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                            className: (0, $2jatx.default)([
                                                "_1e0c11p5 _zulpu2gc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                                                "_1e0c11p5 _yv0ewxkt _1ph4hkll _2osnpxbi"
                                            ]),
                                            children: Object.entries(AiContentExternalLinksInfo).map(([name, provider])=>/*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$ExternalAiProduct, {
                                                    ...provider,
                                                    productKey: productKey
                                                }, name))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkg7ng _18zrxy5q _1rjc1jfw _1fkkukr8"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                            children: intl.formatMessage({
                                id: 'globalnav.ai.resources',
                                defaultMessage: 'Latest news and resources'
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_1e0c11p5 _zulpu2gc _qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                            ]),
                            children: resourceLinks.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)($f3b2a28b3e8594be$var$AiLink, {
                                    ...link,
                                    productKey: productKey
                                }, link.text))
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("5Zqcl", function(module, exports) {
$parcel$export(module.exports, "AiContentExternalLogoSvgs", function () { return $7e3ba58dcc7282fd$export$5add86f1ff968f8e; });

var $7VQPk = parcelRequire("7VQPk");
const $7e3ba58dcc7282fd$export$5add86f1ff968f8e = {
    github: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M8.00003 0C3.5823 0 0 3.49432 0 7.80491C0 11.2534 2.29225 14.179 5.47093 15.211C5.87073 15.2832 6.01754 15.0417 6.01754 14.8355C6.01754 14.6495 6.01008 14.0346 6.00669 13.3824C3.78101 13.8545 3.31138 12.4615 3.31138 12.4615C2.94747 11.5594 2.42313 11.3196 2.42313 11.3196C1.69732 10.8351 2.47784 10.845 2.47784 10.845C3.2812 10.9001 3.70421 11.6494 3.70421 11.6494C4.41773 12.8426 5.57571 12.4976 6.03223 12.2982C6.104 11.7937 6.31137 11.4494 6.54013 11.2545C4.76325 11.0571 2.89527 10.3879 2.89527 7.39729C2.89527 6.54522 3.20779 5.84892 3.71959 5.30236C3.63651 5.10574 3.3627 4.31194 3.79707 3.23686C3.79707 3.23686 4.46886 3.02708 5.99765 4.03691C6.63575 3.86392 7.32015 3.77724 8.00003 3.77431C8.67991 3.77724 9.36481 3.86392 10.0042 4.03691C11.5311 3.02708 12.202 3.23686 12.202 3.23686C12.6374 4.31194 12.3635 5.10574 12.2804 5.30236C12.7933 5.84892 13.1037 6.54515 13.1037 7.39729C13.1037 10.395 11.2322 11.0551 9.45084 11.2483C9.73776 11.4905 9.99343 11.9655 9.99343 12.6937C9.99343 13.7379 9.98415 14.5784 9.98415 14.8355C9.98415 15.0432 10.1281 15.2866 10.5337 15.21C13.7106 14.1768 16 11.2522 16 7.80491C16 3.49432 12.4182 0 8.00003 0Z",
            fill: "#505258"
        })
    }),
    anthropic: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "11",
        viewBox: "0 0 16 11",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M11.2218 0H8.84045L13.1829 10.9714H15.5642L11.2218 0Z",
                fill: "#505258"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M4.34239 0L0 10.9714H2.428L3.31609 8.66743H7.85893L8.74702 10.9714H11.175L6.83264 0H4.34239ZM4.10145 6.6299L5.58752 2.7742L7.0736 6.6299H4.10145Z",
                fill: "#505258"
            })
        ]
    }),
    openAi: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M6.13672 5.772V4.26555C6.13672 4.13868 6.18434 4.0435 6.29528 3.98015L9.3241 2.23585C9.73638 1.998 10.228 1.88706 10.7353 1.88706C12.6382 1.88706 13.8434 3.36181 13.8434 4.93161C13.8434 5.04258 13.8434 5.16946 13.8275 5.29633L10.6877 3.45686C10.4975 3.34592 10.3071 3.34592 10.1169 3.45686L6.13672 5.772ZM13.209 11.6392V8.03954C13.209 7.81749 13.1138 7.65892 12.9236 7.54795L8.94345 5.23281L10.2437 4.48747C10.3547 4.42412 10.4499 4.42412 10.5609 4.48747L13.5897 6.23176C14.4619 6.73925 15.0485 7.81749 15.0485 8.864C15.0485 10.0691 14.335 11.1792 13.209 11.6391V11.6392ZM5.20115 8.46778L3.90086 7.70668C3.78992 7.64333 3.7423 7.54811 3.7423 7.42124V3.93269C3.7423 2.23602 5.04258 0.951495 6.80277 0.951495C7.46886 0.951495 8.08716 1.17355 8.61059 1.56996L5.48672 3.37774C5.2965 3.48868 5.20132 3.64725 5.20132 3.86934V8.46792L5.20115 8.46778ZM7.99998 10.0852L6.13672 9.03863V6.8187L7.99998 5.77216L9.86312 6.8187V9.03863L7.99998 10.0852ZM9.19719 14.9058C8.53114 14.9058 7.91284 14.6838 7.38942 14.2874L10.5132 12.4796C10.7035 12.3686 10.7987 12.2101 10.7987 11.988V7.38942L12.1149 8.15052C12.2258 8.21387 12.2735 8.30905 12.2735 8.43596V11.9245C12.2735 13.6212 10.9572 14.9057 9.19719 14.9057V14.9058ZM5.439 11.3697L2.41018 9.62543C1.53797 9.11791 0.95133 8.03971 0.95133 6.99317C0.95133 5.77216 1.68077 4.67803 2.80657 4.21813V7.83355C2.80657 8.0556 2.90178 8.21417 3.092 8.32515L7.05639 10.6244L5.7561 11.3697C5.64516 11.433 5.54994 11.433 5.439 11.3697ZM5.26467 13.9703C3.47279 13.9703 2.1566 12.6224 2.1566 10.9574C2.1566 10.8305 2.1725 10.7036 2.18826 10.5768L5.31213 12.3845C5.50235 12.4955 5.69275 12.4955 5.88297 12.3845L9.86312 10.0853V11.5918C9.86312 11.7187 9.81553 11.8138 9.70455 11.8772L6.67577 13.6215C6.26346 13.8593 5.77186 13.9703 5.2645 13.9703H5.26467ZM9.19719 15.8572C11.1159 15.8572 12.7174 14.4935 13.0823 12.6857C14.8583 12.2258 16 10.5608 16 8.86417C16 7.7541 15.5243 6.6759 14.668 5.89887C14.7473 5.56584 14.7949 5.23281 14.7949 4.89995C14.7949 2.6324 12.9554 0.935566 10.8305 0.935566C10.4025 0.935566 9.99016 0.99892 9.57784 1.14172C8.86417 0.443972 7.88101 0 6.80277 0C4.88405 0 3.28256 1.36364 2.91771 3.17142C1.14172 3.63132 0 5.29633 0 6.993C0 8.10306 0.475665 9.18126 1.33198 9.9583C1.2527 10.2913 1.20511 10.6244 1.20511 10.9573C1.20511 13.2248 3.04458 14.9216 5.16946 14.9216C5.59753 14.9216 6.00984 14.8582 6.42216 14.7154C7.13567 15.4132 8.11882 15.8572 9.19719 15.8572Z",
            fill: "#505258"
        })
    }),
    google: /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M15.6521 8.19124C15.6521 7.65211 15.5999 7.09559 15.513 6.57385H7.98254V9.65211H12.2956C12.1217 10.6434 11.5478 11.513 10.6956 12.0695L13.2695 14.0695C14.7825 12.6608 15.6521 10.6086 15.6521 8.19124Z",
                fill: "#505258"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.98261 15.9826C10.1391 15.9826 11.9478 15.2696 13.2696 14.0522L10.6957 12.0696C9.98261 12.5565 9.06087 12.8348 7.98261 12.8348C5.89565 12.8348 4.13913 11.4261 3.49565 9.54785L0.852173 11.5826C2.20869 14.2783 4.95652 15.9826 7.98261 15.9826Z",
                fill: "#505258"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M3.49558 9.5304C3.16514 8.5391 3.16514 7.46084 3.49558 6.46953L0.852098 4.41736C-0.278336 6.67823 -0.278336 9.3391 0.852098 11.5826L3.49558 9.5304Z",
                fill: "#505258"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.98261 3.18261C9.11304 3.16522 10.2261 3.6 11.0435 4.38261L13.3217 2.08696C11.8783 0.730437 9.96522 2.07126e-06 7.98261 0.0173934C4.95652 0.0173934 2.20869 1.72174 0.852173 4.4174L3.49565 6.46957C4.13913 4.57392 5.89565 3.18261 7.98261 3.18261Z",
                fill: "#505258"
            })
        ]
    })
};

});


parcelRegister("aBl7x", function(module, exports) {
$parcel$export(module.exports, "useGlobalNavProductRecommendations", function () { return $1181c2878eb1a148$export$8b2dae449a6aff29; });

var $1oC0p = parcelRequire("1oC0p");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $3riD8 = parcelRequire("3riD8");

var $fJROq = parcelRequire("fJROq");

var $cT4PD = parcelRequire("cT4PD");

var $9uve9 = parcelRequire("9uve9");
function $1181c2878eb1a148$export$8b2dae449a6aff29() {
    const [isGlobalNavProductRecommendationsExperimentFailed, setIsGlobalNavProductRecommendationsExperimentFailed] = (0, $1oC0p.useState)(false);
    const { isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const intl = (0, $8e22h.default)();
    const hasEnterpriseEdition = (0, $9uve9.useHasEnterpriseEdition)();
    const { getProductRecommendations: getProductRecommendations, isRecommendationLoading: isRecommendationLoading, recommendations: recommendations } = (0, $cT4PD.useFetchRecommendations)();
    const { fireRenderGlobalNavProductRecommendationsFailed: fireRenderGlobalNavProductRecommendationsFailed, fireGlobalNavProductRecommendationsViewed: fireGlobalNavProductRecommendationsViewed } = (0, $fJROq.useAnalytics)();
    const onGlobalNavProductRecommendationsFailed = (0, $1oC0p.useCallback)((error, errorInfo)=>{
        fireRenderGlobalNavProductRecommendationsFailed(error, errorInfo);
        setIsGlobalNavProductRecommendationsExperimentFailed(true);
    }, [
        fireRenderGlobalNavProductRecommendationsFailed
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (isUserLoggedIn && !hasEnterpriseEdition) getProductRecommendations({
            setIsGlobalNavProductRecommendationsExperimentFailed: setIsGlobalNavProductRecommendationsExperimentFailed
        });
    }, [
        hasEnterpriseEdition,
        getProductRecommendations,
        isUserLoggedIn
    ]);
    const fireGlobalNavProductRecoEventsWhenInView = (0, $1oC0p.useCallback)(({ isMobile: isMobile })=>{
        try {
            if (isUserLoggedIn && !hasEnterpriseEdition && recommendations.length > 0) fireGlobalNavProductRecommendationsViewed({
                recommendations: recommendations,
                isMobile: isMobile
            });
        } catch (_) {
        // Do nothing
        }
    }, [
        recommendations,
        hasEnterpriseEdition,
        isUserLoggedIn,
        fireGlobalNavProductRecommendationsViewed
    ]);
    /**
   * Show the Global Nav Product Recommendations if the user is eligible, and the recommendations are loaded.
   */ const shouldShowGlobalNavProductRecommendations = (0, $1oC0p.useMemo)(()=>{
        const nonEmptyRecosLoaded = !isRecommendationLoading && recommendations.length > 0;
        const shouldShowByRecommendationState = isRecommendationLoading || nonEmptyRecosLoaded;
        return isUserLoggedIn && shouldShowByRecommendationState && !isGlobalNavProductRecommendationsExperimentFailed && !hasEnterpriseEdition;
    }, [
        hasEnterpriseEdition,
        isGlobalNavProductRecommendationsExperimentFailed,
        isRecommendationLoading,
        isUserLoggedIn,
        recommendations.length
    ]);
    const mobileNavPageLabelFeaturedProducts = (0, $1oC0p.useMemo)(()=>{
        return intl.formatMessage((0, $fnHPc.defineMessage)({
            id: 'globalnav.v2.productseveryone.title',
            defaultMessage: 'Featured Products'
        }));
    }, [
        intl
    ]);
    return {
        onGlobalNavProductRecommendationsFailed: onGlobalNavProductRecommendationsFailed,
        shouldShowGlobalNavProductRecommendations: shouldShowGlobalNavProductRecommendations,
        recommendations: recommendations,
        isRecommendationLoading: isRecommendationLoading,
        mobileNavPageLabelFeaturedProducts: mobileNavPageLabelFeaturedProducts,
        fireGlobalNavProductRecoEventsWhenInView: fireGlobalNavProductRecoEventsWhenInView
    };
}

});
parcelRegister("cT4PD", function(module, exports) {
$parcel$export(module.exports, "useFetchRecommendations", function () { return $9c9fb0cdbe76ac1b$export$6501da23a2770fc; });

var $1oC0p = parcelRequire("1oC0p");

var $jAb7e = parcelRequire("jAb7e");

var $cIsCk = parcelRequire("cIsCk");

var $fJROq = parcelRequire("fJROq");
const $9c9fb0cdbe76ac1b$var$WAC_GLOBAL_NAV_PRODUCT_RECOMMENDATION_USE_CASE = 'WACGlobalNavProductRecommendation';
function $9c9fb0cdbe76ac1b$export$6501da23a2770fc() {
    const [isRecommendationLoading, setIsRecommendationLoading] = (0, $1oC0p.useState)(false);
    const isRecommendationLoadedRef = (0, $1oC0p.useRef)(false);
    const [recommendations, setRecommendations] = (0, $1oC0p.useState)([]);
    const { fireFetchGrowthRecommendationSucceeded: fireFetchGrowthRecommendationSucceeded, fireFetchGrowthRecommendationFailed: fireFetchGrowthRecommendationFailed } = (0, $fJROq.useAnalytics)();
    const { getRecommendations: getRecommendations } = (0, $jAb7e.default)({
        endpoint: undefined,
        // use default endpoint
        contextResolver: {
            product: 'marketing',
            useCase: $9c9fb0cdbe76ac1b$var$WAC_GLOBAL_NAV_PRODUCT_RECOMMENDATION_USE_CASE
        }
    });
    const getProductRecommendations = (0, $1oC0p.useCallback)(async ({ setIsGlobalNavProductRecommendationsExperimentFailed: setIsGlobalNavProductRecommendationsExperimentFailed })=>{
        if (isRecommendationLoading || isRecommendationLoadedRef.current) return;
        const startTime = performance.now();
        try {
            setIsRecommendationLoading(true);
            const result = await getRecommendations({
                first: (0, $cIsCk.NUM_DISPLAY_RECOMMENDATIONS),
                rerank: $9c9fb0cdbe76ac1b$export$e15fc74c2b3bb267((0, $cIsCk.ccpKeyToProductId)),
                config: {
                    cacheConfig: {
                        ttl: 60
                    }
                }
            });
            const { response: { data: data } = {} } = result;
            if ($9c9fb0cdbe76ac1b$var$isValidResponse(data)) {
                const recommendedProductIds = data.map(({ entityId: entityId })=>entityId);
                setRecommendations(recommendedProductIds);
                const elapsedTime = performance.now() - startTime;
                fireFetchGrowthRecommendationSucceeded(recommendedProductIds, elapsedTime);
                setIsRecommendationLoading(false);
                isRecommendationLoadedRef.current = true;
            } else throw new Error('Invalid response from App Recommendations API');
        } catch (error) {
            const elapsedTime = performance.now() - startTime;
            const errorMessage = error instanceof Error ? error.message : String(error);
            fireFetchGrowthRecommendationFailed(errorMessage, elapsedTime);
            setIsGlobalNavProductRecommendationsExperimentFailed(true);
            setIsRecommendationLoading(false);
            isRecommendationLoadedRef.current = true;
        }
    }, [
        fireFetchGrowthRecommendationFailed,
        fireFetchGrowthRecommendationSucceeded,
        getRecommendations,
        isRecommendationLoading
    ]);
    return {
        getProductRecommendations: getProductRecommendations,
        isRecommendationLoading: isRecommendationLoading,
        recommendations: recommendations
    };
}
const $9c9fb0cdbe76ac1b$export$e15fc74c2b3bb267 = (entities)=>Object.keys(entities).map((key)=>({
            entityId: key
        }));
/**
 * Ensure the response is valid type
 */ const $9c9fb0cdbe76ac1b$var$isValidResponse = (data)=>{
    return Array.isArray(data);
};

});
parcelRegister("jAb7e", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e41a0078153c1871$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $d20AX = parcelRequire("d20AX");

var $gha1N = parcelRequire("gha1N");

var $k8ibi = parcelRequire("k8ibi");

var $5GTvM = parcelRequire("5GTvM");

var $2kG3g = parcelRequire("2kG3g");
function $e41a0078153c1871$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e41a0078153c1871$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e41a0078153c1871$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e41a0078153c1871$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e41a0078153c1871$var$useRecommendations = function useRecommendations(_ref) {
    var _ref$endpoint = _ref.endpoint, endpoint = _ref$endpoint === void 0 ? '/gateway/api/graphql' : _ref$endpoint, contextResolver = _ref.contextResolver;
    /**
   * Fetch recommendations for a given context
   */ var getRecommendations = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useCallback(function(args) {
        var deprecatedRerank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        // Deconstruct the args object with deprecated arguments to make it backwards compatible
        var _ref2 = typeof args === 'number' ? {
            first: args,
            rerank: deprecatedRerank
        } : args, first = _ref2.first, rerank = _ref2.rerank, _ref2$config = _ref2.config, _ref2$config2 = _ref2$config === void 0 ? {
            cacheConfig: undefined
        } : _ref2$config, cacheConfig = _ref2$config2.cacheConfig;
        var recommendationRequestMaker = new (0, $k8ibi.default)(endpoint);
        var requester = new (0, $2kG3g.default)(new (0, $5GTvM.RecommendationsRequestBroker)());
        var context = (0, $gha1N.getContext)(contextResolver);
        return requester.fetch(recommendationRequestMaker.makeRequest({
            contextResolver: contextResolver,
            first: first,
            rerank: rerank
        }), {
            cacheConfig: cacheConfig ? $e41a0078153c1871$var$_objectSpread($e41a0078153c1871$var$_objectSpread({}, cacheConfig), {}, {
                cacheName: (0, $d20AX.CACHE_NAME),
                useCase: context.useCase
            }) : undefined
        });
    }, [
        contextResolver,
        endpoint
    ]);
    return {
        getRecommendations: getRecommendations
    };
};
var $e41a0078153c1871$export$2e2bcd8739ae039 = $e41a0078153c1871$var$useRecommendations;

});
parcelRegister("d20AX", function(module, exports) {
$parcel$export(module.exports, "CACHE_NAME", function () { return $97cbec763b5145a4$export$14b7e2c312f27acd; });
// Events
var $97cbec763b5145a4$export$38f20466f22f45f0 = 'CLICK_PRIVACY_POLICY_LINK';
var $97cbec763b5145a4$export$836f30b3a88d4259 = 'UNDO_DISMISSAL_STARTED';
var $97cbec763b5145a4$export$5ee3f53555c01a95 = 'UNDO_DISMISSAL_SUCCEEDED';
var $97cbec763b5145a4$export$eebf6a2671000e28 = 'UNDO_DISMISSAL_FAILED';
var $97cbec763b5145a4$export$14b7e2c312f27acd = 'atlassian-growth-recos';

});

parcelRegister("gha1N", function(module, exports) {
$parcel$export(module.exports, "getContext", function () { return $bd9603347281d53c$export$31553aaa555c1514; });

var $2zYm4 = parcelRequire("2zYm4");
function $bd9603347281d53c$export$a079a83b07f794bf(value) {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    if ((0, $2zYm4.default)(value) === 'object' && Object.keys(value).length === 0) return false;
    return true;
}
function $bd9603347281d53c$export$31553aaa555c1514(contextResolver) {
    var checkUseCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (checkUseCase && (typeof (context === null || context === void 0 ? void 0 : context.useCase) !== 'string' || (context === null || context === void 0 ? void 0 : context.useCase.trim().length) === 0)) throw new Error('useCase is required');
    return context;
}

});

parcelRegister("k8ibi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ea82a8669afb93a6$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $imEER = parcelRequire("imEER");
function $ea82a8669afb93a6$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $ea82a8669afb93a6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $ea82a8669afb93a6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ea82a8669afb93a6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ea82a8669afb93a6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_RequestMaker) {
    function RecommendationsRequestMaker() {
        (0, $cTewU.default)(this, RecommendationsRequestMaker);
        return $ea82a8669afb93a6$var$_callSuper(this, RecommendationsRequestMaker, arguments);
    }
    (0, $i7dvh.default)(RecommendationsRequestMaker, _RequestMaker);
    return (0, $avOEA.default)(RecommendationsRequestMaker, [
        {
            key: "makeRequest",
            value: function makeRequest(makeRequestParams) {
                var contextResolver = makeRequestParams.contextResolver, first = makeRequestParams.first, rerank = makeRequestParams.rerank;
                return new Request(this.endpoint, {
                    method: 'POST',
                    credentials: 'include',
                    mode: 'cors',
                    headers: this.getHeaders(),
                    body: JSON.stringify({
                        query: $ea82a8669afb93a6$var$recommendationsQuery,
                        variables: {
                            first: first,
                            context: this.getContext(contextResolver),
                            rerank: rerank
                        }
                    })
                });
            }
        }
    ]);
}((0, $imEER.default));
var $ea82a8669afb93a6$var$recommendationsQuery = "\nquery GrowthRecQuery($context: GrowthRecContext!, $first: Int!, $rerank: [GrowthRecRerankCandidate!]) {\n  growthRecommendations {\n    recommendations(context: $context, first: $first, rerank: $rerank) {\n      ... on GrowthRecRecommendations {\n        __typename\n        data {\n          __typename\n          entityId\n          reasons\n        }\n      }\n      ... on QueryError {\n        __typename\n        identifier\n        message\n        extensions {\n          __typename\n          statusCode\n          errorType\n        }\n      }\n    }\n  }\n}\n";

});
parcelRegister("imEER", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d5e9d1ed63117429$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $gha1N = parcelRequire("gha1N");
var $d5e9d1ed63117429$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RequestMaker(endpoint) {
        (0, $cTewU.default)(this, RequestMaker);
        this.endpoint = endpoint;
    }
    return (0, $avOEA.default)(RequestMaker, [
        {
            key: "getHeaders",
            value: function getHeaders() {
                var headers = new Headers();
                headers.append('Content-Type', 'application/json');
                return headers;
            }
        },
        {
            key: "getContext",
            value: function getContext(contextResolver) {
                return (0, $gha1N.getContext)(contextResolver);
            }
        }
    ]);
}();

});


parcelRegister("5GTvM", function(module, exports) {
$parcel$export(module.exports, "RecommendationsRequestBroker", function () { return $424bef761d9eb5c1$export$7f19312509e0d2c0; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $252p6 = parcelRequire("252p6");
var $424bef761d9eb5c1$export$7f19312509e0d2c0 = /*#__PURE__*/ function() {
    function RecommendationsRequestBroker() {
        (0, $cTewU.default)(this, RecommendationsRequestBroker);
    }
    return (0, $avOEA.default)(RecommendationsRequestBroker, [
        {
            key: "extract",
            value: function extract(response) {
                var _response$recommendat, _response$recommendat2;
                return (_response$recommendat = response === null || response === void 0 || (_response$recommendat2 = response.recommendations) === null || _response$recommendat2 === void 0 ? void 0 : _response$recommendat2.data) !== null && _response$recommendat !== void 0 ? _response$recommendat : [];
            }
        },
        {
            key: "getSuccessResultCreator",
            value: function getSuccessResultCreator(response, result) {
                return new (0, $252p6.RecommendationSuccessResultCreator)(response, result);
            }
        }
    ]);
}();

});
parcelRegister("252p6", function(module, exports) {
$parcel$export(module.exports, "RecommendationSuccessResultCreator", function () { return $183de9c69a26f999$export$c02f0b31b3b527a3; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $cQKhY = parcelRequire("cQKhY");
function $183de9c69a26f999$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $183de9c69a26f999$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $183de9c69a26f999$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($183de9c69a26f999$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $183de9c69a26f999$export$c02f0b31b3b527a3 = /*#__PURE__*/ function(_QuerySuccessResultCr) {
    function RecommendationSuccessResultCreator(response, data) {
        var _this;
        (0, $cTewU.default)(this, RecommendationSuccessResultCreator);
        _this = $183de9c69a26f999$var$_callSuper(this, RecommendationSuccessResultCreator, [
            response,
            data
        ]);
        _this.response = response;
        return _this;
    }
    (0, $i7dvh.default)(RecommendationSuccessResultCreator, _QuerySuccessResultCr);
    return (0, $avOEA.default)(RecommendationSuccessResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new (0, $cQKhY.GraphQlQueryResult)(this.response.status, this.response.statusText, {
                    data: this.data
                });
            }
        }
    ]);
}((0, $cQKhY.QuerySuccessResultCreator));

});
parcelRegister("cQKhY", function(module, exports) {
$parcel$export(module.exports, "GraphQlQueryResult", function () { return $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018; });
$parcel$export(module.exports, "NonOkQueryResultCreator", function () { return $95ae3f64ec4e1ab2$export$ad7cb7f4450dd7c4; });
$parcel$export(module.exports, "GeneralQueryErrorResultCreator", function () { return $95ae3f64ec4e1ab2$export$553722ecbbe27276; });
$parcel$export(module.exports, "MissingQueryDataResultCreator", function () { return $95ae3f64ec4e1ab2$export$ff264bfdc9a404eb; });
$parcel$export(module.exports, "QuerySuccessResultCreator", function () { return $95ae3f64ec4e1ab2$export$6b16771e962990ff; });

var $2qaZZ = parcelRequire("2qaZZ");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $i7dvh = parcelRequire("i7dvh");

var $avOEA = parcelRequire("avOEA");

var $cTewU = parcelRequire("cTewU");
function $95ae3f64ec4e1ab2$var$_callSuper(t, o, e) {
    return o = (0, $jlBwm.default)(o), (0, $i3Ugd.default)(t, $95ae3f64ec4e1ab2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $jlBwm.default)(t).constructor) : o.apply(t, e));
}
function $95ae3f64ec4e1ab2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($95ae3f64ec4e1ab2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018 = /*#__PURE__*/ (0, $avOEA.default)(function GraphQlQueryResult(code, reason, response) {
    (0, $cTewU.default)(this, GraphQlQueryResult);
    this.code = code;
    this.reason = reason;
    this.response = response;
});
var $95ae3f64ec4e1ab2$var$QueryResultCreator = /*#__PURE__*/ (0, $avOEA.default)(function QueryResultCreator() {
    (0, $cTewU.default)(this, QueryResultCreator);
});
var $95ae3f64ec4e1ab2$export$ad7cb7f4450dd7c4 = /*#__PURE__*/ function(_QueryResultCreator) {
    function NonOkQueryResultCreator(fetchResponse) {
        var _this;
        (0, $cTewU.default)(this, NonOkQueryResultCreator);
        _this = $95ae3f64ec4e1ab2$var$_callSuper(this, NonOkQueryResultCreator);
        _this.fetchResponse = fetchResponse;
        return _this;
    }
    (0, $i7dvh.default)(NonOkQueryResultCreator, _QueryResultCreator);
    return (0, $avOEA.default)(NonOkQueryResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText);
            }
        }
    ]);
}($95ae3f64ec4e1ab2$var$QueryResultCreator);
var $95ae3f64ec4e1ab2$export$553722ecbbe27276 = /*#__PURE__*/ function(_QueryResultCreator2) {
    function GeneralQueryErrorResultCreator(errors) {
        var _this2;
        (0, $cTewU.default)(this, GeneralQueryErrorResultCreator);
        _this2 = $95ae3f64ec4e1ab2$var$_callSuper(this, GeneralQueryErrorResultCreator);
        _this2.errors = errors;
        return _this2;
    }
    (0, $i7dvh.default)(GeneralQueryErrorResultCreator, _QueryResultCreator2);
    return (0, $avOEA.default)(GeneralQueryErrorResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                var _this$errors = (0, $2qaZZ.default)(this.errors, 1), extensions = _this$errors[0].extensions;
                var _ref = Array.isArray(extensions) ? extensions : [
                    extensions
                ], _ref2 = (0, $2qaZZ.default)(_ref, 1), _ref2$ = _ref2[0], statusCode = _ref2$.statusCode, errorType = _ref2$.errorType;
                return new $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018(statusCode, errorType, {
                    errors: this.errors.map(function(error) {
                        return error.message;
                    })
                });
            }
        }
    ]);
}($95ae3f64ec4e1ab2$var$QueryResultCreator);
var $95ae3f64ec4e1ab2$export$ff264bfdc9a404eb = /*#__PURE__*/ function(_QueryResultCreator3) {
    function MissingQueryDataResultCreator(fetchResponse) {
        var _this3;
        (0, $cTewU.default)(this, MissingQueryDataResultCreator);
        _this3 = $95ae3f64ec4e1ab2$var$_callSuper(this, MissingQueryDataResultCreator);
        _this3.fetchResponse = fetchResponse;
        return _this3;
    }
    (0, $i7dvh.default)(MissingQueryDataResultCreator, _QueryResultCreator3);
    return (0, $avOEA.default)(MissingQueryDataResultCreator, [
        {
            key: "makeQueryResult",
            value: function makeQueryResult() {
                return new $95ae3f64ec4e1ab2$export$d0a1abfd57dc5018(this.fetchResponse.status, this.fetchResponse.statusText, {
                    errors: [
                        'Received data has missing attributes'
                    ]
                });
            }
        }
    ]);
}($95ae3f64ec4e1ab2$var$QueryResultCreator);
var $95ae3f64ec4e1ab2$export$6b16771e962990ff = /*#__PURE__*/ function(_QueryResultCreator4) {
    function QuerySuccessResultCreator(response, data) {
        var _this4;
        (0, $cTewU.default)(this, QuerySuccessResultCreator);
        _this4 = $95ae3f64ec4e1ab2$var$_callSuper(this, QuerySuccessResultCreator);
        _this4.response = response;
        _this4.data = data;
        return _this4;
    }
    (0, $i7dvh.default)(QuerySuccessResultCreator, _QueryResultCreator4);
    return (0, $avOEA.default)(QuerySuccessResultCreator);
}($95ae3f64ec4e1ab2$var$QueryResultCreator);

});



parcelRegister("2kG3g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1b2e11991bebe1d3$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $cQKhY = parcelRequire("cQKhY");

var $jMzYo = parcelRequire("jMzYo");
/** The requester to make query operation to App Recommendations API via AGG
 *
 * Currently, App Recommendations Service has only a single query (and we only use a single query), which doesn't return any Query errors
 * @see {@link https://developer.atlassian.com/platform/graphql-gateway/standards/query-error/} for more about query errors
 * The query error checking is skipped for now, but it can be added in the future if needed
 */ var $1b2e11991bebe1d3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Requester(broker) {
        (0, $cTewU.default)(this, Requester);
        this.broker = broker;
    }
    /**
   * Fetches the response by the given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The query result
   */ return (0, $avOEA.default)(Requester, [
        {
            key: "fetch",
            value: function fetch1(request) {
                var _this = this;
                var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, cacheConfig = _ref.cacheConfig;
                return new Promise(/*#__PURE__*/ function() {
                    var _ref2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(resolve, reject) {
                        var _json$data;
                        var response, json, schemaResponse, queryRes;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    _context.next = 2;
                                    return _this.getResponse(request, cacheConfig);
                                case 2:
                                    response = _context.sent;
                                    if (response.ok) {
                                        _context.next = 5;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $cQKhY.NonOkQueryResultCreator)(response).makeQueryResult()));
                                case 5:
                                    _context.next = 7;
                                    return response.json();
                                case 7:
                                    json = _context.sent;
                                    if (!json.errors) {
                                        _context.next = 10;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $cQKhY.GeneralQueryErrorResultCreator)(json.errors).makeQueryResult()));
                                case 10:
                                    schemaResponse = json === null || json === void 0 || (_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.growthRecommendations;
                                    queryRes = _this.broker.extract(schemaResponse); // Undefined is not expected as a valid response from GraphQL
                                    if (!(queryRes === undefined)) {
                                        _context.next = 14;
                                        break;
                                    }
                                    return _context.abrupt("return", reject(new (0, $cQKhY.MissingQueryDataResultCreator)(response).makeQueryResult()));
                                case 14:
                                    return _context.abrupt("return", resolve(_this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult()));
                                case 15:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    return function(_x, _x2) {
                        return _ref2.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "getResponse",
            value: function() {
                var _getResponse = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(request, cacheConfig) {
                    var cacheProvider, cachedResponse, clonedRequest;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                cacheProvider = (0, $jMzYo.default).resolve(cacheConfig);
                                _context2.next = 3;
                                return cacheProvider.get(request);
                            case 3:
                                cachedResponse = _context2.sent;
                                if (!cachedResponse) {
                                    _context2.next = 6;
                                    break;
                                }
                                return _context2.abrupt("return", cachedResponse);
                            case 6:
                                // Clone the request before it being used to be able to use it multiple times
                                clonedRequest = request.clone();
                                return _context2.abrupt("return", fetch(request).then(function(response) {
                                    // Cache response only if the response is ok
                                    if (response.ok) cacheProvider.set(clonedRequest, response.clone());
                                    return response;
                                }));
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function getResponse(_x3, _x4) {
                    return _getResponse.apply(this, arguments);
                }
                return getResponse;
            }()
        }
    ]);
}();

});
parcelRegister("jMzYo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e66e678845a31499$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $eRZlG = parcelRequire("eRZlG");

var $f6Frm = parcelRequire("f6Frm");
var $e66e678845a31499$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ResponseCacheProviderResolver() {
        (0, $cTewU.default)(this, ResponseCacheProviderResolver);
    }
    return (0, $avOEA.default)(ResponseCacheProviderResolver, null, [
        {
            key: "resolve",
            value: /**
     * Returns the cache provider based on the given cache configuration
     *
     * @param cacheConfig The cache configuration to use
     * @returns The cache provider
     */ function resolve(cacheConfig) {
                if (cacheConfig) return new (0, $f6Frm.default)(cacheConfig);
                return new (0, $eRZlG.default)();
            }
        }
    ]);
}();

});
parcelRegister("eRZlG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad359a7f9fa92927$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");
var $ad359a7f9fa92927$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NoCache() {
        (0, $cTewU.default)(this, NoCache);
    }
    return (0, $avOEA.default)(NoCache, [
        {
            key: "get",
            value: function() {
                var _get = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(request) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                return _context.abrupt("return", undefined);
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function get(_x) {
                    return _get.apply(this, arguments);
                }
                return get;
            }()
        },
        {
            key: "set",
            value: function() {
                var _set = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(request, response) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return");
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function set(_x2, _x3) {
                    return _set.apply(this, arguments);
                }
                return set;
            }()
        },
        {
            key: "delete",
            value: function() {
                var _delete2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(request) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", true);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _delete(_x4) {
                    return _delete2.apply(this, arguments);
                }
                return _delete;
            }()
        }
    ]);
}();

});

parcelRegister("f6Frm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aff78fbdd9dd2c19$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $2zYm4 = parcelRequire("2zYm4");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $5Cxn4 = parcelRequire("5Cxn4");

var $5PZ9Y = parcelRequire("5PZ9Y");

var $kOoh1 = parcelRequire("kOoh1");
var $aff78fbdd9dd2c19$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Whether the Cache API is supported
   */ /**
   * Expiry storage
   */ /**
   * Initialise the WebCacheStorage
   * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
   * @param onError a callback when any error occurs
   */ function WebCacheStorage(cacheProviderConfig) {
        (0, $cTewU.default)(this, WebCacheStorage);
        this.supported = (typeof caches === "undefined" ? "undefined" : (0, $2zYm4.default)(caches)) === 'object' && typeof caches.open === 'function';
        this.cacheConfig = new (0, $5PZ9Y.default)(cacheProviderConfig);
        this.expiryStorage = new (0, $kOoh1.default)(this.cacheConfig);
    }
    /**
   * Get cached response
   */ return (0, $avOEA.default)(WebCacheStorage, [
        {
            key: "get",
            value: function() {
                var _get = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(request) {
                    var cache, expired;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.supported) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", undefined);
                            case 2:
                                _context.prev = 2;
                                _context.next = 5;
                                return caches.open(this.cacheConfig.cacheName);
                            case 5:
                                cache = _context.sent;
                                _context.next = 8;
                                return this.isExpired(request);
                            case 8:
                                expired = _context.sent;
                                if (!expired) {
                                    _context.next = 13;
                                    break;
                                }
                                _context.next = 12;
                                return this.delete(request);
                            case 12:
                                return _context.abrupt("return", undefined);
                            case 13:
                                return _context.abrupt("return", cache.match(this.getCacheKey(request)));
                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context["catch"](2);
                                this.cacheConfig.onError(_context.t0);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            16
                        ]
                    ]);
                }));
                function get(_x) {
                    return _get.apply(this, arguments);
                }
                return get;
            }()
        },
        {
            key: "set",
            value: function() {
                var _set = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(request, response) {
                    var cache, expiryDate;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (this.supported) {
                                    _context2.next = 2;
                                    break;
                                }
                                return _context2.abrupt("return");
                            case 2:
                                _context2.prev = 2;
                                _context2.next = 5;
                                return caches.open(this.cacheConfig.cacheName);
                            case 5:
                                cache = _context2.sent;
                                expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
                                _context2.next = 9;
                                return this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
                            case 9:
                                _context2.next = 11;
                                return cache.put(this.getCacheKey(request), response);
                            case 11:
                                _context2.next = 16;
                                break;
                            case 13:
                                _context2.prev = 13;
                                _context2.t0 = _context2["catch"](2);
                                this.cacheConfig.onError(_context2.t0);
                            case 16:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            2,
                            13
                        ]
                    ]);
                }));
                function set(_x2, _x3) {
                    return _set.apply(this, arguments);
                }
                return set;
            }()
        },
        {
            key: "delete",
            value: function() {
                var _delete2 = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(request) {
                    var _this = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (this.supported) {
                                    _context4.next = 2;
                                    break;
                                }
                                return _context4.abrupt("return", true);
                            case 2:
                                _context4.prev = 2;
                                return _context4.abrupt("return", caches.open(this.cacheConfig.cacheName).then(/*#__PURE__*/ function() {
                                    var _ref = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(cache) {
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                                            while(true)switch(_context3.prev = _context3.next){
                                                case 0:
                                                    _context3.next = 2;
                                                    return cache.delete(_this.getCacheKey(request));
                                                case 2:
                                                    _context3.next = 4;
                                                    return _this.expiryStorage.deleteExpiry(_this.getStoreKey(request));
                                                case 4:
                                                    return _context3.abrupt("return", true);
                                                case 5:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }, _callee3);
                                    }));
                                    return function(_x5) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()));
                            case 6:
                                _context4.prev = 6;
                                _context4.t0 = _context4["catch"](2);
                                this.cacheConfig.onError(_context4.t0);
                                return _context4.abrupt("return", false);
                            case 10:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this, [
                        [
                            2,
                            6
                        ]
                    ]);
                }));
                function _delete(_x4) {
                    return _delete2.apply(this, arguments);
                }
                return _delete;
            }()
        },
        {
            key: "isExpired",
            value: function() {
                var _isExpired = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee5(request) {
                    var key, expiry;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.prev = 0;
                                key = this.getStoreKey(request);
                                _context5.next = 4;
                                return this.expiryStorage.getExpiry(key);
                            case 4:
                                expiry = _context5.sent;
                                return _context5.abrupt("return", Date.now() > (expiry !== null && expiry !== void 0 ? expiry : 0));
                            case 8:
                                _context5.prev = 8;
                                _context5.t0 = _context5["catch"](0);
                                this.cacheConfig.onError(_context5.t0 instanceof Error ? _context5.t0 : new Error('Error checking expiry'));
                                return _context5.abrupt("return", true);
                            case 12:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function isExpired(_x6) {
                    return _isExpired.apply(this, arguments);
                }
                return isExpired;
            }()
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(request) {
                var url = new URL(request.url);
                url.searchParams.set('useCase', this.cacheConfig.useCase);
                return url;
            }
        },
        {
            key: "getStoreKey",
            value: function getStoreKey(request) {
                return this.getCacheKey(request).toString();
            }
        }
    ]);
}();

});
parcelRegister("5PZ9Y", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $44012843d4c19c08$export$2e2bcd8739ae039; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");
var $44012843d4c19c08$var$DEFAULT_TTL = 60;
var $44012843d4c19c08$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function CacheConfig(cacheProviderConfig) {
        (0, $cTewU.default)(this, CacheConfig);
        this.cacheProviderConfig = cacheProviderConfig;
    }
    return (0, $avOEA.default)(CacheConfig, [
        {
            key: "cacheName",
            get: function get() {
                return this.cacheProviderConfig.cacheName;
            }
        },
        {
            key: "useCase",
            get: function get() {
                return this.cacheProviderConfig.useCase;
            }
        },
        {
            key: "ttl",
            get: function get() {
                var _this$cacheProviderCo;
                return (_this$cacheProviderCo = this.cacheProviderConfig.ttl) !== null && _this$cacheProviderCo !== void 0 ? _this$cacheProviderCo : $44012843d4c19c08$var$DEFAULT_TTL;
            }
        },
        {
            key: "onError",
            get: function get() {
                var _this$cacheProviderCo2;
                return (_this$cacheProviderCo2 = this.cacheProviderConfig.onError) !== null && _this$cacheProviderCo2 !== void 0 ? _this$cacheProviderCo2 : function() {};
            }
        }
    ]);
}();

});

parcelRegister("kOoh1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f26b4e665d4a143b$export$2e2bcd8739ae039; });

var $cn8ql = parcelRequire("cn8ql");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");
/**
 * Expiry storage that stores the expiry date of the cached response
 */ var $f26b4e665d4a143b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Initialise the ExpiryStorage
   */ function ExpiryStorage(cacheConfig) {
        (0, $cTewU.default)(this, ExpiryStorage);
        (0, $f53LC.default)(this, "expiryStoreName", 'expiries');
        this.cacheConfig = cacheConfig;
    }
    /**
   * Set the expiry date of the cached response
   */ return (0, $avOEA.default)(ExpiryStorage, [
        {
            key: "setExpiry",
            value: function() {
                var _setExpiry = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(key, expireAt) {
                    var _this = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                return _context.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this.getObjectStore(dbRequest, 'readwrite');
                                        store.put(expireAt, key);
                                        resolve();
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function setExpiry(_x, _x2) {
                    return _setExpiry.apply(this, arguments);
                }
                return setExpiry;
            }()
        },
        {
            key: "getExpiry",
            value: function() {
                var _getExpiry = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(key) {
                    var _this2 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this2.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this2.getObjectStore(dbRequest, 'readonly');
                                        var storeRequest = store.get(key);
                                        storeRequest.onsuccess = function() {
                                            var _storeRequest$result;
                                            resolve(Number((_storeRequest$result = storeRequest.result) !== null && _storeRequest$result !== void 0 ? _storeRequest$result : 0));
                                        };
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function getExpiry(_x3) {
                    return _getExpiry.apply(this, arguments);
                }
                return getExpiry;
            }()
        },
        {
            key: "deleteExpiry",
            value: function() {
                var _deleteExpiry = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(key) {
                    var _this3 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", new Promise(function(resolve, reject) {
                                    var dbRequest = _this3.initDb();
                                    dbRequest.onsuccess = function() {
                                        var store = _this3.getObjectStore(dbRequest, 'readwrite');
                                        store.delete(key);
                                        resolve();
                                    };
                                    dbRequest.onerror = function() {
                                        if (dbRequest.error) reject(dbRequest.error);
                                    };
                                }));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function deleteExpiry(_x4) {
                    return _deleteExpiry.apply(this, arguments);
                }
                return deleteExpiry;
            }()
        },
        {
            key: "initDb",
            value: function initDb() {
                var _this4 = this;
                var dbRequest = indexedDB.open("".concat(this.cacheConfig.cacheName, "-expiry"));
                dbRequest.onupgradeneeded = function() {
                    var db = dbRequest.result;
                    db.createObjectStore(_this4.expiryStoreName);
                };
                return dbRequest;
            }
        },
        {
            key: "getObjectStore",
            value: function getObjectStore(dbRequest) {
                var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'readwrite';
                var db = dbRequest.result;
                return db.transaction(this.expiryStoreName, mode).objectStore(this.expiryStoreName);
            }
        }
    ]);
}();

});






parcelRegister("9uve9", function(module, exports) {
$parcel$export(module.exports, "useHasEnterpriseEdition", function () { return $5cd2010e18cc205f$export$d412e290bea9bfac; });

var $1oC0p = parcelRequire("1oC0p");

var $bv77X = parcelRequire("bv77X");
function $5cd2010e18cc205f$export$d412e290bea9bfac() {
    const { sites: sites = [] } = (0, $bv77X.useSitesContext)();
    const hasEnterpriseEdition = (0, $1oC0p.useMemo)(()=>sites.some((site)=>site.edition?.toLowerCase() === 'enterprise'), [
        sites
    ]);
    return hasEnterpriseEdition;
}

});


parcelRegister("Q3GOe", function(module, exports) {
$parcel$export(module.exports, "useResourcesData", function () { return $29bb8f9829fce176$export$33143093180b06fc; });
$parcel$export(module.exports, "useResourcesLinks", function () { return $29bb8f9829fce176$export$d033c7ddb6c3fb52; });
$parcel$export(module.exports, "GlobalNavResourcesDropdown", function () { return $29bb8f9829fce176$export$50e552a50c313b04; });
/* global-nav-resources-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $aIIww = parcelRequire("aIIww");

var $jsxHL = parcelRequire("jsxHL");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $MV9vM = parcelRequire("MV9vM");

var $8nFt2 = parcelRequire("8nFt2");

var $dzoWS = parcelRequire("dzoWS");

var $jgdMW = parcelRequire("jgdMW");

var $9KOR3 = parcelRequire("9KOR3");
function $29bb8f9829fce176$export$33143093180b06fc() {
    const templatesHref = (0, $jQ0cd.useLocalizedHref)('/templates');
    return [
        {
            id: 'resources.customer-support',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.customer-support.title',
                defaultMessage: 'Customer Support'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.customer-support.content',
                defaultMessage: 'Ask questions, report bugs & give us feedback'
            }),
            href: '//support.atlassian.com/'
        },
        {
            id: 'resources.template-gallery',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.template-gallery.title',
                defaultMessage: 'Templates'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.template-gallery.content',
                defaultMessage: 'Ready-made workflows for every team.'
            }),
            href: templatesHref,
            isNew: true
        },
        {
            id: 'resources.find-partners',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.find-partners.title',
                defaultMessage: 'Find Partners'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.find-partners.content',
                defaultMessage: 'Consulting, training & product customization support'
            }),
            href: (0, $aIIww.useLocalizedPartnerdirectory)()
        },
        {
            id: 'resources.migration-program',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.migration-program.title',
                defaultMessage: 'Atlassian Ascend'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.migration-program.content',
                defaultMessage: 'Resources and support for your transformation'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/migration')
        },
        {
            id: 'resources.community',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.community.title',
                defaultMessage: 'Community'
            }),
            content: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.community.content',
                defaultMessage: 'Learn, connect and grow with the Atlassian Community'
            }),
            href: '//community.atlassian.com/'
        }
    ];
}
function $29bb8f9829fce176$export$d033c7ddb6c3fb52() {
    const usageHref = (0, $jQ0cd.useLocalizedHref)('/resources/usage');
    const usageCalculatorHref = (0, $jQ0cd.useLocalizedHref)('/resources/usage/calculator');
    const isUsageBasedPricingEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp11118UsageBasedPricingCalculator);
    return {
        support: {
            id: 'support',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.links.support',
                defaultMessage: 'Support'
            }),
            items: [
                {
                    id: 'general-inquiries',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.general-inquiries',
                        defaultMessage: 'General Inquiries'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/company/contact/general-inquiries')
                },
                {
                    id: 'technical-support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.technical-support',
                        defaultMessage: 'Technical Support'
                    }),
                    href: '//support.atlassian.com/contact/'
                },
                {
                    id: 'product-advice',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.product-advice',
                        defaultMessage: 'Product Advice'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/company/contact/product-evaluator-advice')
                },
                {
                    id: 'pricing-billing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.pricing-billing',
                        defaultMessage: 'Pricing and Billing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/company/contact/purchasing-licensing')
                },
                {
                    id: 'partner-support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.partner-support',
                        defaultMessage: 'Partner Support'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/partners')
                },
                {
                    id: 'developer-support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.developer-support',
                        defaultMessage: 'Developer Support'
                    }),
                    href: '//developer.atlassian.com/'
                },
                {
                    id: 'enterprise-support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.enterprise-support',
                        defaultMessage: 'Enterprise Support'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/enterprise/services')
                },
                {
                    id: 'purchasing-licensing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.purchasing-billing',
                        defaultMessage: 'Purchasing and Licensing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/licensing/purchase-licensing')
                }
            ]
        },
        learn: {
            id: 'resources',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.resources.links.resources',
                defaultMessage: 'Resources'
            }),
            items: [
                {
                    id: 'project-management',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.project-management',
                        defaultMessage: 'Project Management'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/project-management')
                },
                {
                    id: 'project-collaboration',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.project-collaboration',
                        defaultMessage: 'Project Collaboration'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/work-management/project-collaboration')
                },
                {
                    id: 'agile',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.agile',
                        defaultMessage: 'Agile'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/agile')
                },
                {
                    id: 'team-playbook',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.team-playbook',
                        defaultMessage: 'Team Playbook'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/team-playbook')
                },
                {
                    id: 'learning',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.learning',
                        defaultMessage: 'Atlassian Learning'
                    }),
                    href: '//community.atlassian.com/learning'
                },
                {
                    id: 'product-documentation',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.product-documentation',
                        defaultMessage: 'Product Documentation'
                    }),
                    href: '//confluence.atlassian.com/display/ALLDOC/Atlassian+Documentation'
                },
                {
                    id: 'get-started',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.resources.links.get-started',
                        defaultMessage: 'Get Started'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/get-started')
                },
                ...isUsageBasedPricingEnabled ? [
                    {
                        id: 'usage',
                        text: (0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.resources.links.usage',
                            defaultMessage: 'Usage-based Pricing'
                        }),
                        href: usageHref
                    },
                    {
                        id: 'usage-calculator',
                        text: (0, $fnHPc.defineMessage)({
                            id: 'globalnavv2.subnav.resources.links.usage-calculator',
                            defaultMessage: 'Usage Calculator'
                        }),
                        href: usageCalculatorHref
                    }
                ] : []
            ]
        }
    };
}
const $29bb8f9829fce176$var$ResourcesGrid = ({ children: children, numCols: numCols = 4 })=>{
    const gridTemplateColumns = Array(numCols).fill('1fr').join(' ');
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0e76xy _1p571jfw _gy1pxy5q _1rjc1jfw _18zr1jfw _2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        style: {
            "--_64rtn9": (0, $6ZVlx.default)(gridTemplateColumns)
        },
        children: children
    });
};
const $29bb8f9829fce176$export$50e552a50c313b04 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const resourcesData = $29bb8f9829fce176$export$33143093180b06fc();
    const resourcesLinks = $29bb8f9829fce176$export$d033c7ddb6c3fb52();
    const linkColumns = Object.values(resourcesLinks);
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8nFt2.MotionContainer), {
                direction: direction,
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($29bb8f9829fce176$var$ResourcesGrid, {
                        numCols: 3,
                        children: resourcesData.map(({ id: id, title: title, content: content, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MV9vM.TitleCard), {
                                    title: intl.formatMessage(title),
                                    content: intl.formatMessage(content),
                                    productKey: productKey,
                                    ...rest
                                })
                            }, id))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_bfhkg7ng"
                        ]),
                        style: {
                            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                            numCols: 2,
                            columnGap: "var(--ds-space-400, 32px)",
                            paddingBlock: "var(--ds-space-500, 40px)",
                            paddingInline: "var(--ds-space-500, 40px)",
                            children: linkColumns.map((column)=>{
                                return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dzoWS.GlobalNavDropdownLinkColumn), {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                                            removeMargin: true,
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                                ...column.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                            className: (0, $2jatx.default)([
                                                "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q14y2 _u5f3idpf _n3tdidpf _19bvidpf"
                                            ]),
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                                                numCols: 2,
                                                columnGap: "var(--ds-space-400, 32px)",
                                                numRows: 3,
                                                rowHeight: "var(--ds-space-500, 40px)",
                                                children: column.items.map((link)=>{
                                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                                        className: (0, $2jatx.default)([
                                                            "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                            className: (0, $2jatx.default)([
                                                                "_bpsp1nn1 _19tboxwj _1la11k8s _43ds1pfd _1e0c1txw _4cvrh9n0"
                                                            ]),
                                                            style: {
                                                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                            },
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                                type: "anchor",
                                                                href: link.href,
                                                                text: intl.formatMessage(link.text),
                                                                ariaLabel: intl.formatMessage(link.text),
                                                                dataEventProps: {
                                                                    'data-event': 'clicked',
                                                                    'data-event-component': 'linkButton',
                                                                    'data-event-container': 'globalNavSubnav',
                                                                    'data-product-key': productKey
                                                                },
                                                                "aria-label": intl.formatMessage(link.text)
                                                            })
                                                        }, link.id)
                                                    }, link.id);
                                                })
                                            })
                                        })
                                    ]
                                }, column.id);
                            })
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("aIIww", function(module, exports) {
$parcel$export(module.exports, "useLocalizedPartnerdirectory", function () { return $b23a5b1c5c6b9ebc$export$e8e649555cc9721a; });
$parcel$export(module.exports, "useLocalizedPartnerDirectoryHref", function () { return $b23a5b1c5c6b9ebc$export$ba1bcbad28261cae; });

var $3fFrT = parcelRequire("3fFrT");

var $17RBn = parcelRequire("17RBn");
const $b23a5b1c5c6b9ebc$var$localeMap = {
    [(0, $3fFrT.DEFAULT_LOCALE)]: '',
    de: 'de',
    es: 'es',
    fr: 'fr',
    it: 'it',
    ko: 'ko',
    nl: 'nl',
    ja: 'ja',
    pl: 'pl',
    br: 'br',
    ru: 'ru',
    zh: 'zh',
    ro: 'ro',
    cs: 'cs',
    hu: 'hu',
    fi: 'fi',
    xx: 'xx',
    zz: 'zz'
};
function $b23a5b1c5c6b9ebc$export$e8e649555cc9721a() {
    const locale = (0, $17RBn.useLocale)();
    return `//partnerdirectory.atlassian.com/${$b23a5b1c5c6b9ebc$var$localeMap[locale] || $b23a5b1c5c6b9ebc$var$localeMap[0, $3fFrT.DEFAULT_LOCALE]}`;
}
function $b23a5b1c5c6b9ebc$export$265340d886a0f5c7(url) {
    return url.includes('//partnerdirectory.atlassian.com/');
}
function $b23a5b1c5c6b9ebc$export$ba1bcbad28261cae(url) {
    const localizedPartnerDirectoryUrl = $b23a5b1c5c6b9ebc$export$e8e649555cc9721a();
    const locale = (0, $17RBn.useLocale)();
    if ($b23a5b1c5c6b9ebc$export$265340d886a0f5c7(url) && locale !== (0, $3fFrT.DEFAULT_LOCALE)) return url.replace('//partnerdirectory.atlassian.com/', `${localizedPartnerDirectoryUrl}/`);
    return url;
}

});

parcelRegister("MV9vM", function(module, exports) {
$parcel$export(module.exports, "TitleCard", function () { return $3e7e0535c18352cb$export$b39c77b32b32f068; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $3pg5Q = parcelRequire("3pg5Q");
const $3e7e0535c18352cb$var$cardStyles = null;
const $3e7e0535c18352cb$var$hoverIconStyles = null;
const $3e7e0535c18352cb$var$CardTitleCardContentStyle = null;
const $3e7e0535c18352cb$var$CardTitleAnchorLinkStyle = null;
const $3e7e0535c18352cb$var$dropdownTitleStyles = null;
const $3e7e0535c18352cb$var$iconContainerStyles = null;
const $3e7e0535c18352cb$var$iconStyles = null;
const $3e7e0535c18352cb$export$b39c77b32b32f068 = ({ title: title, icon: icon, content: content, href: href, productKey: productKey = 'home', isNew: isNew })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _1bsbvlwb _1s4p1osq _6ssjzu5n _kbawglyw _1x381ule"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("a", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _syaz1qc2 _1e0c1ule _10531kw7 _f8pj5hrz _30l35hrz _l8kux7w3",
                "title-card-link"
            ]),
            href: href,
            target: (0, $jQ0cd.isLocalizableHref)(href) ? '' : '_blank',
            rel: (0, $jQ0cd.isLocalizableHref)(href) ? '' : 'noreferrer',
            "aria-label": `${title}: ${content}`,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "globalNavSubnav",
            "data-product-key": productKey,
            style: {
                "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800')),
                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
            },
            children: [
                !!icon && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_6rth1mvu"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1ule _4cvrh9n0 _4t3i14no _1bsb14no",
                                "default-icon"
                            ]),
                            children: icon.normal
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1ule _4cvrh9n0 _4t3i14no _1bsb14no",
                                "_1e0cglyw",
                                "hover-icon"
                            ]),
                            children: icon.hover
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_vwz44jg8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _4cvr1h6o _1n261q9c _zulpi2wt _syaz1pfd _k48p1fw0 _10531kw7 _f8pj5hrz _30l35hrz _1wyb1j6v _1dyz18hd _p7r1116y _t1edidpf _1v7x19bv _1aaynkob _cli0yu22 _9p8e1fw0 _1s16angw",
                        "titleCard-title"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                    },
                    children: [
                        title,
                        isNew && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.Pill), {
                            children: "New"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1wybjosm _vwz44jg8 _syaz1qc2 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1dyzidpf",
                        "titleCard-content"
                    ]),
                    style: {
                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                    },
                    children: content
                })
            ]
        })
    });
};
const $3e7e0535c18352cb$var$linkCardStyles = null;
const $3e7e0535c18352cb$export$2c381a86421d5abf = ({ href: href, text: text, productKey: productKey = 'home' })=>{
    const localizedHref = (0, $jQ0cd.useLocalizedHref)(href);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19it1xhx _2rko1j6v _43ds1pfd _19tboxwj _1df31pfd"
        ]),
        style: {
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
            href: localizedHref,
            text: text,
            ariaLabel: text,
            type: "primary",
            dataEventProps: {
                'data-event': 'clicked',
                'data-event-component': 'linkButton',
                'data-event-container': 'globalNavSubnav',
                'data-product-key': productKey
            }
        })
    });
};

});


parcelRegister("8DdYy", function(module, exports) {
$parcel$export(module.exports, "GlobalNavSolutionsDropdown", function () { return $a5ab63ea3778e91d$export$83f1e56729c29f53; });
/* global-nav-solutions-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $kxzNq = parcelRequire("kxzNq");

var $dzoWS = parcelRequire("dzoWS");

var $9KOR3 = parcelRequire("9KOR3");
function $a5ab63ea3778e91d$var$useNewSolutionLinks() {
    return {
        byUseCase: {
            id: 'byUseCase',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.teams.links.column.by-use-case',
                defaultMessage: 'By Use Case'
            }),
            items: [
                {
                    id: 'team-collaboration',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.team-collaboration',
                        defaultMessage: 'Team collaboration'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/collections/teamwork')
                },
                {
                    id: 'strategy-and-planning',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.strategy-and-planning',
                        defaultMessage: 'Strategy and planning'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/collections/strategy')
                },
                {
                    id: 'service-management',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.service-management',
                        defaultMessage: 'Service management'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/collections/service')
                },
                {
                    id: 'software-development',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.software-development',
                        defaultMessage: 'Software development'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/dev')
                }
            ]
        },
        teamtype: {
            id: 'teamtype',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.teams.links.column.teamtype',
                defaultMessage: 'By Team'
            }),
            items: [
                {
                    id: 'software',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.software',
                        defaultMessage: 'Software'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/dev')
                },
                {
                    id: 'marketing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.marketing',
                        defaultMessage: 'Marketing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/teams/marketing')
                },
                {
                    id: 'it',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.it',
                        defaultMessage: 'IT'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/teams/it')
                },
                {
                    id: 'product-discovery-by-team',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.product-discovery-by-team',
                        defaultMessage: 'Product'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery ')
                }
            ]
        },
        byTeamSize: {
            id: 'byTeamSize',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.teams.links.column.by-team-size',
                defaultMessage: 'By Size'
            }),
            items: [
                {
                    id: 'enterprise',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.enterprise',
                        defaultMessage: 'Enterprise'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
                },
                {
                    id: 'small-business',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.small-business',
                        defaultMessage: 'Small Business'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/small-business')
                },
                {
                    id: 'startup',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.startup',
                        defaultMessage: 'Startup'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/startups')
                },
                {
                    id: 'non-profit',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.non-profit',
                        defaultMessage: 'Non-profit'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/teams/nonprofits')
                }
            ]
        },
        byIndustry: {
            id: 'byIndustry',
            title: (0, $fnHPc.defineMessage)({
                id: 'globalnavv2.subnav.teams.links.column.by-industry',
                defaultMessage: 'By Industry'
            }),
            items: [
                {
                    id: 'retail',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.retail',
                        defaultMessage: 'Retail'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/industries/retail')
                },
                {
                    id: 'telecommunications',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.telecommunications',
                        defaultMessage: 'Telecommunications'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/industries/telecom')
                },
                {
                    id: 'professional-services',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.professional-services',
                        defaultMessage: 'Professional Services'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/industries/professional-services')
                },
                {
                    id: 'government',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'globalnavv2.subnav.teams.links.government',
                        defaultMessage: 'Government'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/government')
                }
            ]
        }
    };
}
const $a5ab63ea3778e91d$export$83f1e56729c29f53 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    const newSolutionsLinks = $a5ab63ea3778e91d$var$useNewSolutionLinks();
    const newGlobalNavDropdownLinkColumns = Object.values(newSolutionsLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _12rrp2n4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _ect41vau _1wyboqnp _1p1dangw _18s8gx6n _1mjb1ule",
                            "mobile-label"
                        ]),
                        style: {
                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                        },
                        children: intl.formatMessage({
                            id: 'GlobalNav.collections.solutions.mobilelabel',
                            defaultMessage: 'Solutions'
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $8nFt2.MotionContainer), {
                        direction: direction,
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bfhkg7ng _1e0c11p5 _yv0e1ajj _zulp1ejb _18zr1jfw _1rjc1jfw _xc2ize3t _1bhlze3t _1ph4hkll _xlt1xy5q _uk5u1afi",
                                    "new-solutions-bottom"
                                ]),
                                style: {
                                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                                },
                                children: newGlobalNavDropdownLinkColumns.map((column)=>{
                                    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dzoWS.GlobalNavDropdownLinkColumn), {
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavEyebrow), {
                                                removeMargin: true,
                                                children: intl.formatMessage(column.title)
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_1e0c11p5 _2z051wug"
                                                ]),
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                                    className: (0, $2jatx.default)([
                                                        "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q14y2 _u5f3idpf _n3tdidpf _19bvidpf _144to7ao"
                                                    ]),
                                                    children: column.items.map((link)=>{
                                                        return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                                            className: (0, $2jatx.default)([
                                                                "_2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qftgi _u5f3idpf _n3tdftgi _19bvidpf"
                                                            ]),
                                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                                className: (0, $2jatx.default)([
                                                                    "_bpsp1nn1 _19tboxwj _43ds1pfd _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1pfd _oavv5hrz _oxk45hrz _1byu5hrz _1o7v5hrz _1e0c1txw _4cvrh9n0"
                                                                ]),
                                                                style: {
                                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                                },
                                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                                    type: "anchor",
                                                                    href: link.href,
                                                                    text: intl.formatMessage(link.text),
                                                                    "aria-label": intl.formatMessage(link.text),
                                                                    ariaLabel: intl.formatMessage(link.text),
                                                                    dataEventProps: {
                                                                        'data-event': 'clicked',
                                                                        'data-event-component': 'linkButton',
                                                                        'data-event-container': 'globalNavSubnav',
                                                                        'data-product-key': productKey
                                                                    }
                                                                })
                                                            }, link.id)
                                                        }, link.id);
                                                    })
                                                })
                                            })
                                        ]
                                    }, column.id);
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kxzNq.RovoSection), {})
                        ]
                    })
                ]
            })
        })
    });
};
const $a5ab63ea3778e91d$var$SolutionsContainerCSS = null;
const $a5ab63ea3778e91d$var$CollectionsMobileLabelCSS = null;
const $a5ab63ea3778e91d$var$CollectionsSolutionsBottomCSS = null;

});

parcelRegister("gisLk", function(module, exports) {
$parcel$export(module.exports, "useWhyAtlassianData", function () { return $605916ba887f51fd$export$e75d7d5034191e1; });
$parcel$export(module.exports, "GlobalNavWhyAtlassianDropdown", function () { return $605916ba887f51fd$export$f7682c439485f779; });
/* global-nav-why-atlassian-dropdown.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $MV9vM = parcelRequire("MV9vM");

var $8nFt2 = parcelRequire("8nFt2");

var $9KOR3 = parcelRequire("9KOR3");
function $605916ba887f51fd$export$e75d7d5034191e1() {
    const intl = (0, $8e22h.default)();
    return [
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.systemofwork.title',
                defaultMessage: 'System of Work'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.systemofwork.content',
                defaultMessage: "Atlassian's blueprint for how teams work together"
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/system-of-work')
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.ecosystem.title',
                defaultMessage: 'Ecosystem'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.ecosystem.content',
                defaultMessage: 'Connect tools, teams, and agents into one intelligent system of work'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/ecosystem'),
            isNew: true
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.integrations.title',
                defaultMessage: 'Marketplace'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.integrations.content',
                defaultMessage: 'Connect thousands of apps to your Atlassian products'
            }),
            href: '//marketplace.atlassian.com/'
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.customers.title',
                defaultMessage: 'Customers'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.customers.content',
                defaultMessage: 'Case studies & stories powered by teamwork'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/customers')
        },
        {
            title: 'FedRAMP',
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.fedramp.content',
                defaultMessage: 'Compliant solutions for the public sector'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/trust/compliance/resources/fedramp')
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.resilience.title',
                defaultMessage: 'Resilience'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.resilience.content',
                defaultMessage: 'Enterprise-grade & highly performant infrastructure'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/trust/resilience')
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.platform.title',
                defaultMessage: 'Platform'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.platform.content',
                defaultMessage: 'Our deeply integrated, reliable & secure platform'
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/platform')
        },
        {
            title: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.trustcenter.title',
                defaultMessage: 'Trust center'
            }),
            content: intl.formatMessage({
                id: 'globalnavv2.subnav.whyatlassian.trustcenter.content',
                defaultMessage: "Ensure your data's security, compliance & availability"
            }),
            href: (0, $jQ0cd.useLocalizedHref)('/trust')
        }
    ];
}
const $605916ba887f51fd$var$WhyAtlassianGrid = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _yv0e1ajj _1p571jfw _gy1pxy5q _1rjc1jfw _18zr1jfw _2mzuglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
        ]),
        children: children
    });
};
const $605916ba887f51fd$export$f7682c439485f779 = ({ productKey: productKey = 'home' })=>{
    const teamsData = $605916ba887f51fd$export$e75d7d5034191e1();
    const { direction: direction } = (0, $9KOR3.useGlobalNavContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: direction,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($605916ba887f51fd$var$WhyAtlassianGrid, {
                    children: teamsData.map(({ title: title, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MV9vM.TitleCard), {
                                title: title,
                                ...rest,
                                productKey: productKey
                            }, title)
                        }, title))
                })
            })
        })
    });
};

});

parcelRegister("3hAMp", function(module, exports) {
$parcel$export(module.exports, "GlobalNavMobileMenu", function () { return $1cab40d3a0528704$export$f9ef5f8ab01a323b; });
/* global-nav-mobile-menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $clnBI = parcelRequire("clnBI");

var $59F4T = parcelRequire("59F4T");

var $jQ0cd = parcelRequire("jQ0cd");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $5yuBp = parcelRequire("5yuBp");

var $5X1Oi = parcelRequire("5X1Oi");

var $kNyc7 = parcelRequire("kNyc7");

var $aTTHV = parcelRequire("aTTHV");

var $atJnX = parcelRequire("atJnX");

var $8DdYy = parcelRequire("8DdYy");

var $3R5TL = parcelRequire("3R5TL");

var $2a9sZ = parcelRequire("2a9sZ");

var $lB6jo = parcelRequire("lB6jo");

var $czCwT = parcelRequire("czCwT");

var $7LWkZ = parcelRequire("7LWkZ");

var $h3FQ3 = parcelRequire("h3FQ3");

var $4ytX0 = parcelRequire("4ytX0");

var $gdkcl = parcelRequire("gdkcl");

var $c0gDI = parcelRequire("c0gDI");
const $1cab40d3a0528704$var$shownInnerMobileDropdownMenuStyle = null;
const $1cab40d3a0528704$var$hiddenInnerMobileDropdownMenuStyle = null;
const $1cab40d3a0528704$var$slideInLeftKeyframes = null;
const $1cab40d3a0528704$var$slideInDown = null;
const $1cab40d3a0528704$var$slideInUp = null;
const $1cab40d3a0528704$var$slideInRight = null;
const $1cab40d3a0528704$var$defaultInnerMenuCss = null;
const $1cab40d3a0528704$var$slideInLeftCss = null;
const $1cab40d3a0528704$var$slideInDownCss = null;
const $1cab40d3a0528704$var$slideInUpCss = null;
const $1cab40d3a0528704$var$slideInRightCss = null;
const $1cab40d3a0528704$var$backButtonCss = null;
const $1cab40d3a0528704$var$MobileGlobalNavDropdownMenu = ({ isUserLoggedIn: isUserLoggedIn, menuPage: menuPage = 'default', firstOpen: firstOpen, mobileLinksSections: mobileLinksSections, handleMenuPage: handleMenuPage, handleFirstOpen: handleFirstOpen, productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const isNavigatingBackRef = (0, $1oC0p.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const isMobile = (0, $5yuBp.useIsMobile)();
    const isAiTabEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).team26EuRefresh);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            menuPage === 'default' && isMobile ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1q511tcg",
                    isNavigatingBackRef.current && "",
                    isNavigatingBackRef.current && "_tzy4idpf _y44v1s1a"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kNyc7.default), {
                    isMobileView: true,
                    readOnly: true,
                    parentType: "GlobalNav",
                    menuPage: menuPage,
                    fullWidth: true,
                    onFocus: ()=>{
                        if (!isNavigatingBackRef.current) handleMenuPage('search');
                        createAnalyticsEvent({
                            eventName: 'searchOpen',
                            eventType: 'ui',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'searchButtonMobileV2',
                            source: 'globalNav',
                            attributes: {
                                product: 'marketing',
                                pageUrl: window.location.href,
                                pagePath: window.location.pathname
                            }
                        }).fire();
                    }
                }, "default-search-bar")
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {}),
            (menuPage === 'resources' || menuPage === 'product-everyone' || menuPage === 'product-developer' || menuPage === 'product-product-managers' || menuPage === 'product-it-professionals' || menuPage === 'product-business-teams' || menuPage === 'product-leadership-teams' || menuPage === 'solutions' || menuPage === 'ai' || menuPage === 'why-atlassian') && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpu2gc _ahbq1b66 _1pfhu2gc _6rthu2gc _1ywm1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    style: {
                        all: 'unset',
                        width: 'fit-content'
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        isNavigatingBackRef.current = true;
                        handleFirstOpen(false);
                        handleMenuPage('default');
                        // reset the flag after navigation
                        setTimeout(()=>{
                            isNavigatingBackRef.current = false;
                        }, 100);
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_y44voibr",
                            "_syaz6x5g _1e0c1txw _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                                label: "",
                                spacing: "spacious"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: intl.formatMessage({
                                    id: 'globalnavv2.menu-back',
                                    defaultMessage: 'Back'
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_tzy4idpf _v564g4i2 _15qekb7n _1uewkb7n",
                    !firstOpen && "",
                    !firstOpen && "_y44vobx7",
                    !firstOpen && "",
                    !firstOpen && "_y44voibr",
                    menuPage === 'default' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    `firstopen inner-mobile-dropdown-menu ${firstOpen ? 'fade-in' : 'slide-in-left'}`
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aTTHV.ContactSalesCta), {
                        isFullWidth: true
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3R5TL.MobileNavLinks), {
                        isLoggedIn: isUserLoggedIn,
                        handleMenuPage: handleMenuPage,
                        mobileLinksSections: mobileLinksSections,
                        productKey: productKey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-everyone' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-everyone-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $atJnX.GlobalNavFeaturedCollectionDropdown), {
                    isMobile: true
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-developer' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-developer-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $czCwT.MobileNavProductDevelopers), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-product-managers' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "product-managers-inner inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4ytX0.MobileNavProductProductManagers), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-it-professionals' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7LWkZ.MobileNavProductITProfessionals), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-business-teams' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lB6jo.MobileNavProductBusinessTeams), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'product-leadership-teams' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $h3FQ3.MobileNavProductLeadershipTeams), {})
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'teams' || menuPage === 'solutions' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8DdYy.GlobalNavSolutionsDropdown), {})
            }),
            isAiTabEnabled && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'ai' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5X1Oi.AiContent), {
                    productKey: productKey
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'why-atlassian' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $c0gDI.MobileNavWhyAtlassian), {
                    productKey: productKey
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_y44vobx7",
                    menuPage === 'resources' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "inner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gdkcl.MobileNavResources), {
                    productKey: productKey
                })
            }),
            menuPage === 'search' && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    menuPage === 'search' ? "_1e0c1ule _tzy4kb7n _v564g4i2 _18s84jca _1s6b1uce" : "_1e0cglyw _tzy4idpf _v564g4i2 _18s84jca",
                    "searchpageinnermenuinner-mobile-dropdown-menu"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            style: {
                                all: 'unset',
                                width: 'fit-content'
                            },
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                isNavigatingBackRef.current = true;
                                handleFirstOpen(false);
                                handleMenuPage('default');
                                // reset the flag after navigation
                                setTimeout(()=>{
                                    isNavigatingBackRef.current = false;
                                }, 100);
                            },
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_y44voibr",
                                    "_syaz6x5g _1e0c1txw _4cvr1h6o _1q517vkz"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                                        label: "",
                                        spacing: "spacious"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: intl.formatMessage({
                                            id: 'globalnavv2.menu-back',
                                            defaultMessage: 'Back'
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_tzy4idpf _y44v8blq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kNyc7.default), {
                                isMobileView: true,
                                parentType: "GlobalNav",
                                menuPage: menuPage,
                                fullWidth: true
                            }, "search-page-search-bar")
                        })
                    ]
                })
            }, "search-page")
        ]
    });
};
const $1cab40d3a0528704$export$f9ef5f8ab01a323b = ({ productKey: productKey, state: state })=>{
    const intl = (0, $8e22h.default)();
    const { userInfo: userInfo, showMenu: showMenu, isDisplayLoggedInUseDropdown: isDisplayLoggedInUseDropdown, firstOpen: firstOpen, menuPage: menuPage, handleToggleMenu: handleToggleMenu, handleFirstOpen: handleFirstOpen, handleMenuPage: handleMenuPage } = state;
    const { onSwitchAccountClick: onSwitchAccountClick, onManageProfileClick: onManageProfileClick, onManageLicensesClick: onManageLicensesClick, onLogOutClick: onLogOutClick } = (0, $59F4T.useGlobalNavUserProfileClickActions)({
        email: userInfo.email
    });
    const teamsText = intl.formatMessage({
        id: 'globalNavigation.Navlink.solutions',
        defaultMessage: 'Solutions'
    });
    const teamsKeyAndDropdownType = 'solutions';
    const isAiTabEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).team26EuRefresh);
    const mobileLinksSections = [
        {
            mobileLinkKey: 'product-nav-links',
            isIncludeBottomDivider: true,
            mobileLinksProps: [
                {
                    globalLinksKey: 'products',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.products',
                        defaultMessage: 'Products'
                    }),
                    hasDropdown: false
                },
                {
                    globalLinksKey: 'everyone',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.featured',
                        defaultMessage: 'Featured'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-everyone'
                },
                {
                    globalLinksKey: 'developers',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.developers',
                        defaultMessage: 'Developers'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-developer'
                },
                {
                    globalLinksKey: 'productmanagers',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.productmanagers',
                        defaultMessage: 'Product Managers'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-product-managers'
                },
                {
                    globalLinksKey: 'itprofessionals',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.itprofessionals',
                        defaultMessage: 'IT professionals'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-it-professionals'
                },
                {
                    globalLinksKey: 'businessteams',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.businessteams',
                        defaultMessage: 'Business Teams'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-business-teams'
                },
                {
                    globalLinksKey: 'leadershipteams',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.leadershipteams',
                        defaultMessage: 'Leadership Teams'
                    }),
                    hasDropdown: true,
                    dropdownType: 'product-leadership-teams'
                }
            ]
        },
        {
            mobileLinkKey: 'other-nav-links',
            mobileLinksProps: [
                ...isAiTabEnabled ? [
                    {
                        globalLinksKey: 'ai',
                        linkText: intl.formatMessage({
                            id: 'globalnavv2.navlink.ai',
                            defaultMessage: 'AI'
                        }),
                        hasDropdown: true,
                        dropdownType: 'ai'
                    }
                ] : [],
                {
                    globalLinksKey: teamsKeyAndDropdownType,
                    linkText: teamsText,
                    hasDropdown: true,
                    dropdownType: teamsKeyAndDropdownType
                },
                {
                    globalLinksKey: 'why-atlassian',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.whyAtlassian',
                        defaultMessage: 'Why Atlassian'
                    }),
                    hasDropdown: true,
                    dropdownType: 'why-atlassian'
                },
                {
                    globalLinksKey: 'resources',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.resources',
                        defaultMessage: 'Resources'
                    }),
                    hasDropdown: true,
                    dropdownType: 'resources'
                },
                {
                    globalLinksKey: 'enterprise',
                    linkText: intl.formatMessage({
                        id: 'globalnavv2.navlink.enterprise',
                        defaultMessage: 'Enterprise'
                    }),
                    hasDropdown: false,
                    href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
                }
            ]
        }
    ];
    return isDisplayLoggedInUseDropdown ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2a9sZ.default), {
        userInfo: {
            displayName: userInfo.name || '',
            email: userInfo.email || '',
            avatar: userInfo.picture || ''
        },
        onLogOutClick: onLogOutClick,
        onManageLicensesClick: onManageLicensesClick,
        onManageProfileClick: onManageProfileClick,
        onSwitchAccountClick: onSwitchAccountClick
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)($1cab40d3a0528704$var$MobileGlobalNavDropdownMenu, {
        showMenu: showMenu,
        isUserLoggedIn: userInfo.isUserLoggedIn,
        menuPage: menuPage,
        firstOpen: firstOpen,
        mobileLinksSections: mobileLinksSections,
        handleToggleMenu: handleToggleMenu,
        handleMenuPage: handleMenuPage,
        handleFirstOpen: handleFirstOpen,
        productKey: productKey
    });
};

});
parcelRegister("lB6jo", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductBusinessTeams", function () { return $40485381a52c82a8$export$6a303a69999cf50c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $40485381a52c82a8$export$6a303a69999cf50c = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const businessTeamsProducts = productsByTag[(0, $3pg5Q.ProductCategory).BusinessTeams] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).BusinessTeams].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: businessTeamsProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).BusinessTeams
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("czCwT", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductDevelopers", function () { return $d9f0265905ee4b3a$export$d2e2cabc7ee48967; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $d9f0265905ee4b3a$export$d2e2cabc7ee48967 = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const developersProducts = productsByTag[(0, $3pg5Q.ProductCategory).Developers] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).Developers].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: developersProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).Developers
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("7LWkZ", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductITProfessionals", function () { return $7da55e49b2d9a409$export$a00033f672d28a41; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $7da55e49b2d9a409$export$a00033f672d28a41 = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const itProfessionalsProducts = productsByTag[(0, $3pg5Q.ProductCategory).ITProfessionals] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).ITProfessionals].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: itProfessionalsProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).ITProfessionals
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("h3FQ3", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductLeadershipTeams", function () { return $dc93b8153816ca1e$export$8f7556a31a879079; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $dc93b8153816ca1e$export$8f7556a31a879079 = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const leadershipTeamsProducts = productsByTag[(0, $3pg5Q.ProductCategory).LeadershipTeams] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).LeadershipTeams].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: leadershipTeamsProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).LeadershipTeams
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("4ytX0", function(module, exports) {
$parcel$export(module.exports, "MobileNavProductProductManagers", function () { return $87bdf77bd7bccf06$export$8bcbf0310429d54d; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3pg5Q = parcelRequire("3pg5Q");

var $jbgN3 = parcelRequire("jbgN3");
const $87bdf77bd7bccf06$export$8bcbf0310429d54d = ()=>{
    const intl = (0, $8e22h.default)();
    const { productsByTag: productsByTag } = (0, $3pg5Q.useProductData)();
    const productManagersProducts = productsByTag[(0, $3pg5Q.ProductCategory).ProductManagers] || [];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage((0, $3pg5Q.categories)[(0, $3pg5Q.ProductCategory).ProductManagers].title)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductGrid), {
                children: productManagersProducts.map((product)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $3pg5Q.ProductItem), {
                        ...product,
                        currentCategory: (0, $3pg5Q.ProductCategory).ProductManagers
                    }, product.id))
            })
        ]
    });
};

});

parcelRegister("gdkcl", function(module, exports) {
$parcel$export(module.exports, "MobileNavResources", function () { return $1ab13b0899c10eab$export$83bd5439901f0f7f; });
/* mobile-nav-resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $MV9vM = parcelRequire("MV9vM");

var $Q3GOe = parcelRequire("Q3GOe");

var $jbgN3 = parcelRequire("jbgN3");
const $1ab13b0899c10eab$var$mobileLinkListCss = null;
const $1ab13b0899c10eab$export$83bd5439901f0f7f = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const resourcesData = (0, $Q3GOe.useResourcesData)();
    const resourcesLinks = (0, $Q3GOe.useResourcesLinks)();
    const linkColumns = Object.values(resourcesLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage({
                    id: 'globalnav.v2.resources.title',
                    defaultMessage: 'Resources'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: resourcesData.map(({ id: id, title: title, content: content, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $MV9vM.TitleCard), {
                            title: intl.formatMessage(title),
                            content: intl.formatMessage(content),
                            productKey: productKey,
                            ...rest
                        })
                    }, id))
            }),
            linkColumns.map((section)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_11q7g7ng _18s8urp9 _1yt4xy5q"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            style: {
                                margin: 0,
                                textTransform: 'uppercase',
                                fontSize: '0.75rem'
                            },
                            children: intl.formatMessage(section.title)
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                            className: (0, $2jatx.default)([
                                "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _e3ub1bpf"
                            ]),
                            children: section.items.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        type: "anchor",
                                        href: link.href,
                                        text: intl.formatMessage(link.text),
                                        ariaLabel: intl.formatMessage(link.text),
                                        dataEventProps: {
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'globalNavSubnav',
                                            'data-product-key': productKey
                                        }
                                    })
                                }, link.id))
                        })
                    ]
                }, section.id))
        ]
    });
};

});

parcelRegister("c0gDI", function(module, exports) {
$parcel$export(module.exports, "MobileNavWhyAtlassian", function () { return $50c76f65d5751cef$export$15a36ea830bd3411; });
/* mobile-nav-why-atlassian.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $MV9vM = parcelRequire("MV9vM");

var $gisLk = parcelRequire("gisLk");

var $jbgN3 = parcelRequire("jbgN3");
const $50c76f65d5751cef$var$mobileWhyAtlassianGridCss = null;
const $50c76f65d5751cef$export$15a36ea830bd3411 = ({ productKey: productKey = 'home' })=>{
    const intl = (0, $8e22h.default)();
    const whyAtlassianData = (0, $gisLk.useWhyAtlassianData)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jbgN3.MobileNavTitle), {
                title: intl.formatMessage({
                    id: 'globalnav.v2.whyatlassian.title',
                    defaultMessage: 'Why Atlassian'
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _zulpidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
                ]),
                children: whyAtlassianData.map(({ title: title, ...rest })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $MV9vM.TitleCard), {
                        title: title,
                        ...rest,
                        productKey: productKey
                    }, title))
            })
        ]
    });
};

});


parcelRegister("igXd8", function(module, exports) {
$parcel$export(module.exports, "CompoundSubNav", function () { return $6052244f048f0d1c$export$2e7b57b2b3287680; });
/* nav-global-compound-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $clnBI = parcelRequire("clnBI");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $3PWZ2 = parcelRequire("3PWZ2");

var $4Rcm1 = parcelRequire("4Rcm1");

var $9KOR3 = parcelRequire("9KOR3");
const $6052244f048f0d1c$var$compoundSubNavPadding = "var(--ds-space-100, 8px)";
const $6052244f048f0d1c$var$linkableCompoundSubNavTitleStyle = null;
const $6052244f048f0d1c$export$2e7b57b2b3287680 = ({ compoundSubNavTitle: compoundSubNavTitle, compoundSubNavLinksProps: compoundSubNavLinksProps, productKey: productKey = 'home', optionalClassName: optionalClassName = '', compoundSubNavTitleHref: compoundSubNavTitleHref = '' })=>{
    const compoundSubNavStyle = null;
    const compoundSubNavBarStyle = null;
    const compoundSubNavTitleStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
        "aria-label": compoundSubNavTitle,
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _bfhk1afi _4t3i18pe _18zru2gc _d2ik1n1m _exxmnatz _kjzlu23k _vqaqu23k _12z714n7 _qc27idpf _rbmh1g6m",
            `compoundSubNav ${optionalClassName}`
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_eiqaqt": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).height),
            "--_1mhfb35": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).outerInset),
            "--_17s1s73": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).compoundEndInset),
            "--_84k7f0": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).menuItemPadding),
            "--_x0psmk": (0, $6ZVlx.default)((0, $4Rcm1.navGrid).compoundStartInsetWide),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_4cvr1h6o _1bah1yb4 _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _kqswh2mm _1bsb1osq _p12ftfvk _18zru2gc _owpuidpf _10jxglyw",
                "compoundSubNavBar"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4bfu1r31 _1hmsglyw _ajmmnqa1 _k48p1fw0 _1wybgktf _vwz4gktf _1o9zidpf _o5721q9c _bozgu2gc _d2ikidpf",
                        "compoundSubNavTitle"
                    ]),
                    children: [
                        compoundSubNavTitleHref && /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                            href: compoundSubNavTitleHref,
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "navbar",
                            "data-label": compoundSubNavTitle,
                            "data-product-key": productKey,
                            className: (0, $2jatx.default)([
                                "_f8pj5hrz _30l35hrz _1ien5hrz _n0fx5hrz"
                            ]),
                            style: {
                                "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                            },
                            children: compoundSubNavTitle
                        }),
                        compoundSubNavTitleHref.length === 0 && compoundSubNavTitle
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)($6052244f048f0d1c$var$CompoundSubNavLinks, {
                    compoundSubNavLinksProps: compoundSubNavLinksProps,
                    productKey: productKey
                })
            ]
        })
    });
};
$6052244f048f0d1c$export$2e7b57b2b3287680.displayName = 'CompoundSubNav';
const $6052244f048f0d1c$var$CompoundSubNavLinks = ({ compoundSubNavLinksProps: compoundSubNavLinksProps, productKey: productKey = 'home' })=>{
    const linksContainerWrapperStyle = null;
    const linksContainerStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1bsb1osq _4t3i1osq _kqswh2mm _4cvr1h6o _1bahesu3 _msup1yb4",
            "compoundSubNavLinksContainer"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3i1osq _bozgu2gc _1e0cglyw _dm251ule _d2ikidpf",
                    "compoundSubNavLinks"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.default), {
                    globalLinksProps: compoundSubNavLinksProps,
                    isCompoundSubnav: true
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($6052244f048f0d1c$var$CompoundSubNavDropdownLinks, {
                compoundSubNavLinksProps: compoundSubNavLinksProps,
                productKey: productKey
            })
        ]
    });
};
const $6052244f048f0d1c$var$CompoundSubNavDropdownLinks = ({ compoundSubNavLinksProps: compoundSubNavLinksProps, productKey: productKey = 'home' })=>{
    const dropdownContentStyle = null;
    const [isOpen, setIsOpen] = (0, $1oC0p.useState)(false);
    const [onCaretButton, setOnCaretButton] = (0, $1oC0p.useState)(false);
    const [activeDropdownKey, setActiveDropdownKey] = (0, $1oC0p.useState)(null);
    const intl = (0, $8e22h.default)();
    const menuId = (0, $1oC0p.useId)();
    const dropdownRef = (0, $1oC0p.useRef)(null);
    (0, $1oC0p.useLayoutEffect)(()=>{
        const panel = dropdownRef.current;
        if (!isOpen || !panel) return;
        const updateHeight = ()=>{
            const viewport = window.visualViewport;
            const bottom = viewport ? viewport.offsetTop + viewport.height : document.documentElement.clientHeight;
            panel.style.setProperty('--compound-nav-dropdown-height', `${Math.max(0, bottom - panel.getBoundingClientRect().top)}px`);
        };
        updateHeight();
        const observer = new ResizeObserver(updateHeight);
        const nav = panel.closest('nav');
        if (nav) observer.observe(nav);
        window.addEventListener('resize', updateHeight);
        window.addEventListener('scroll', updateHeight, {
            passive: true
        });
        window.visualViewport?.addEventListener('resize', updateHeight);
        window.visualViewport?.addEventListener('scroll', updateHeight);
        return ()=>{
            observer.disconnect();
            window.removeEventListener('resize', updateHeight);
            window.removeEventListener('scroll', updateHeight);
            window.visualViewport?.removeEventListener('resize', updateHeight);
            window.visualViewport?.removeEventListener('scroll', updateHeight);
        };
    }, [
        isOpen
    ]);
    const backButtonRef = (0, $1oC0p.useRef)(null);
    const activeDropdown = compoundSubNavLinksProps.find((link)=>link.globalLinksKey === activeDropdownKey);
    const handleEscKeyEvent = (0, $1oC0p.useCallback)((event)=>{
        if (event.key === 'Escape') {
            setIsOpen(false);
            setActiveDropdownKey(null);
        }
    }, []);
    const handleClickOutside = (0, $1oC0p.useCallback)((event)=>{
        if (isOpen && !dropdownRef.current?.contains(event.target) && !onCaretButton) {
            setIsOpen(false);
            setActiveDropdownKey(null);
        }
    }, [
        isOpen,
        onCaretButton
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (activeDropdownKey) backButtonRef.current?.focus();
    }, [
        activeDropdownKey
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // Attach the listeners on component mount.
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscKeyEvent, false);
        // Detach the listeners on component unmount.
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscKeyEvent, false);
        };
    }, [
        handleEscKeyEvent,
        handleClickOutside
    ]);
    const linkClickAction = (e)=>{
        e.preventDefault();
        setIsOpen((prevIsOpen)=>{
            if (prevIsOpen) setActiveDropdownKey(null);
            return !prevIsOpen;
        });
    };
    const rotate180deg = null;
    const fadeOutKeyframes = null;
    const fadeOutAnimation = null;
    const tabletDropdownGap = "var(--ds-space-100, 8px)";
    const tabletDropdownTopGap = "var(--ds-space-050, 4px)";
    const tabletDropdownHeight = `var(--compound-nav-dropdown-height, calc(100dvh - 136px - ${tabletDropdownTopGap}))`;
    const dropdownContainerStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1ule _bozg1n1m _y4ti1b66 _15vtu23k _dm25glyw _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf",
            "compoundSubNavDropdownLinks"
        ]),
        style: {
            "--_1mhfb35": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).outerInset),
            "--_84k7f0": (0, $6ZVlx.default)((0, $4Rcm1.navLayout).menuItemPadding)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                onClick: linkClickAction,
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseEnter: ()=>{
                    setOnCaretButton(true);
                },
                // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
                onMouseLeave: ()=>{
                    setOnCaretButton(false);
                },
                "aria-label": intl.formatMessage({
                    id: 'compoundSubNav.openDropdown',
                    defaultMessage: 'Open navigation menu'
                }),
                "aria-expanded": isOpen,
                "aria-controls": menuId,
                "data-event": "clicked",
                "data-event-component": "linkButton",
                "data-event-container": "headerDropdownLink",
                "data-label": intl.formatMessage({
                    id: 'compoundSubNav.openDropdown',
                    defaultMessage: 'Open navigation menu'
                }),
                "data-product-key": productKey,
                "data-testid": "compoundSubNavDropdownLinksCaretButton",
                className: (0, $2jatx.default)([
                    "_bfhk1j28 _19itglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _vwz4idpf _v5641doz",
                        isOpen && "_t9ec1sub",
                        "chevron-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "15",
                        height: "10",
                        viewBox: "0 0 15 10",
                        fill: "none",
                        "aria-hidden": "true",
                        focusable: "false",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                            d: "M0.571934 1.12105C0.441394 1.25145 0.337835 1.40629 0.267179 1.57674C0.196524 1.74718 0.160156 1.92988 0.160156 2.11439C0.160156 2.2989 0.196524 2.48159 0.267179 2.65204C0.337835 2.82248 0.441394 2.97733 0.571934 3.10772L6.6346 9.18372C6.75846 9.30789 6.90559 9.4064 7.06758 9.47362C7.22956 9.54084 7.40322 9.57544 7.5786 9.57544C7.75398 9.57544 7.92764 9.54084 8.08962 9.47362C8.25161 9.4064 8.39874 9.30789 8.5226 9.18372L14.5893 3.10639C14.8524 2.84329 15.0002 2.48646 15.0002 2.11439C15.0002 1.74232 14.8524 1.38548 14.5893 1.12239C14.3262 0.859292 13.9693 0.711487 13.5973 0.711487C13.2252 0.711487 12.8684 0.859292 12.6053 1.12239L7.5786 6.15705L2.5546 1.12239C2.42446 0.992129 2.26992 0.888796 2.09982 0.818295C1.92972 0.747793 1.7474 0.711505 1.56327 0.711505C1.37914 0.711505 1.19681 0.747793 1.02671 0.818295C0.856613 0.888796 0.702076 0.992129 0.571934 1.12239V1.12105Z",
                            fill: (0, $kbpa7.wacToken)('color.primary.black')
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                id: menuId,
                ref: dropdownRef,
                "aria-hidden": !isOpen,
                className: (0, $2jatx.default)([
                    "_1e0cglyw _tzy4kb7n _1rjcpxbi _18zr1ejb _rjxp1qka _152t1osq _1bsb8hk1 _4t3i1w9h _kqswstnw _1f49b4wl _bfhk1afi _v564122b _1pbyzo7u _zulputpp _dwk3usvi _1bv01wug _1d2yncxg _14b51ris _kiya1b66 _1xlo1h9b _1kkmo7ao _z21jglyw _nxbc130s",
                    isOpen && "_1e0c1txw _2lx21bp4",
                    !isOpen && "",
                    !isOpen && "_y44v10i3"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0cglyw _kzvi1ule _em6n1n9t _1vxp5k2d _mmgkidpf _12rrauwl _1vkh1osq _18ooglyw _195y12a9 _1d0q6vh0 _4ik01mrw"
                        ])
                    }),
                    activeDropdown ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                                ref: backButtonRef,
                                type: "button",
                                onClick: ()=>setActiveDropdownKey(null),
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _zulpu2gc _19itglyw _bfhk1j28 _syaz5hrz _1yt4u2gc _1ygb1qgu _1ah3yh40"
                                ]),
                                style: {
                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($clnBI))), {
                                        label: ""
                                    }),
                                    intl.formatMessage({
                                        id: 'globalnavv2.menu-back',
                                        defaultMessage: 'Back'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                children: activeDropdown.content
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        children: compoundSubNavLinksProps.map((link)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1rjcpxbi _1bsb1osq"
                                ]),
                                children: link.hasDropdown ? /*#__PURE__*/ (0, $7VQPk.jsx)($6052244f048f0d1c$var$CompoundNavDropdownLinkWithDropdown, {
                                    ...link,
                                    onOpen: ()=>setActiveDropdownKey(link.globalLinksKey)
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)($6052244f048f0d1c$var$CompoundNavDropdownLink, {
                                    ...link
                                })
                            }, link.globalLinksKey))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1ule _181nglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3PWZ2.Divider), {})
                    })
                ]
            })
        ]
    });
};
const $6052244f048f0d1c$var$dropdownLinkStyle = null;
const $6052244f048f0d1c$var$CompoundNavDropdownLink = (link)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: (0, $jQ0cd.useLocalizedHref)(link.href),
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "navbarDropdown",
        "data-label": link.linkText,
        "data-product-key": link.productKey,
        className: (0, $2jatx.default)([
            "_ect4z4z1 _1wybdlk8 _k48p1fw0 _syaz1pfd _vwz4gktf _4t3igktf _30l35hrz",
            "_1e0c1o8l _1bsb1osq"
        ]),
        style: {
            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
        },
        children: link.linkText
    });
};
const $6052244f048f0d1c$var$CompoundNavDropdownLinkWithDropdown = ({ linkText: linkText, productKey: productKey, onOpen: onOpen })=>{
    const dropdownLinkButtonStyle = null;
    const dropdownCaret = /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "6",
        height: "10",
        viewBox: "0 0 6 10",
        fill: "none",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M1.36328 1L4.99964 5L1.36328 9",
            stroke: (0, $kbpa7.wacToken)('color.primary.black'),
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
        type: "button",
        onClick: onOpen,
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": "navbarDropdown",
        "data-label": linkText,
        "data-product-key": productKey,
        className: (0, $2jatx.default)([
            "_80omtlke _1e0c1txw _1bsb1osq _1bah1yb4 _4cvr1h6o _4t3igktf _vwz4gktf _19itglyw _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_ect4z4z1 _1wybdlk8 _k48p1fw0 _syaz1pfd _vwz4gktf _4t3igktf _30l35hrz"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                },
                children: linkText
            }),
            dropdownCaret
        ]
    });
};

});



//# sourceMappingURL=404.7a72e109.js.map
